{
  "buffs": {
    "settingsCard": {
      "hint": "管理已新增的 BUFF，點擊「設定」調整提醒。",
      "add": "新增 BUFF",
      "empty": "尚未新增 BUFF，新增後可在這裡設定提醒。",
      "edit": "設定 {name}",
      "threshold": "提前 {seconds} 秒",
      "reminderOff": "提前提醒已關閉"
    },
    "manualTimer": {
      "label": "手動定時",
      "unit": "秒",
      "helpLabel": "瞭解手動定時",
      "help": "辨識準確時同步遊戲，辨識不到時繼續倒數。",
      "helpDetails": "歸零按設定秒數循環。修改秒數重新計時，中斷連線即停止。",
      "helpExample": "場景舉例：開啟後，先成功辨識一次「神聖祈禱」的倒數計時，之後即使某一輪沒吃到神聖祈禱，也能按設定的時間繼續提醒。",
      "waiting": "等待辨識倒數計時",
      "running": "手動定時中 · 每{seconds}秒循環",
      "remaining": "手動定時 · 剩餘 {value} 秒",
      "invalid": "請輸入 1～86400 的整數秒數"
    },
    "monitorNotReady": "監控尚未就緒",
    "unrecognized": "未辨識到",
    "activeUntimed": "已生效",
    "paused": "監控暫停",
    "frameInterrupted": "畫面中斷",
    "remaining": "剩餘 {value} 秒",
    "itemSettings": {
      "heading": "提醒設定",
      "monitor": "監控此 BUFF",
      "nearing": "即將結束",
      "seconds": "秒前",
      "visual": "圖示閃爍",
      "speech": "語音播報",
      "shared": "所有 BUFF 共用",
      "priorityHint": "數字越大，播報越優先",
      "speaking": "正在播報",
      "retryAudition": "重新試聽",
      "delete": "刪除 BUFF",
      "saving": "儲存中…",
      "saved": "已儲存"
    },
    "imageRecognition": "影象識別",
    "defaultRegionHint": "預設搜尋畫面頂部 30%，覆蓋整行及多行 BUFF，避開底部快捷欄。可拖動框體、拖動右下角調整大小，或修改下方百分比。",
    "dropShort": "也可拖入圖片",
    "localPrivate": "僅儲存在本機",
    "catalogShort": "技能目錄 · 包含非 BUFF 項",
    "itemCatalogShort": "道具目錄 · 包含非 BUFF 項",
    "source": "線上搜尋類別",
    "skills": "技能",
    "items": "道具",
    "searchItems": "搜尋道具關鍵字",
    "automaticDetection": "自動識別",
    "automaticDetectionHint": "新增 BUFF 並連線遊戲視窗後，自動定點陣圖標與識別秒數，無需先手動框選。",
    "close": "關閉",
    "character": "人物狀態",
    "clickSettings": "點選開啟設定",
    "tooltipDrag": "拖動排序",
    "dragHint": "拖動排序 · Alt＋方向鍵移動",
    "save": "儲存",
    "customRules": "單獨設定",
    "buffDefaults": "BUFF 提醒",
    "advanced": "更多設定",
    "emptyBar": "新增你關心的狀態，連線遊戲後自動監控。",
    "filter": "職業篩選",
    "adding": "正在新增",
    "addCount": "新增 {count} 個",
    "iconHint": "空間不足時先縮小，再自動換行。",
    "recognitionTab": "統計識別",
    "buffCalibration": "BUFF 識別",
    "savedCount": "已新增 {count} 個 BUFF",
    "reconnectHint": "畫面已中斷，請透過上方採集區重新連線遊戲視窗。",
    "autoHint": "欄內 BUFF 連線後自動監控，刪除即停止",
    "previewHint": "統計使用示例資料，BUFF 使用當前狀態。拖動預覽右下角可以調整尺寸。",
    "skinSettings": "前往設定更換統計外觀",
    "autoSaved": "設定自動儲存在本機",
    "advancedDiagnostic": "高階診斷",
    "regionFields": {
      "x": "左側位置",
      "y": "頂部位置",
      "width": "寬度",
      "height": "高度"
    },
    "alertEvents": "何時提醒",
    "alertChannels": "提醒方式",
    "previousPage": "上一頁",
    "nextPage": "下一頁",
    "previewState": "預覽狀態",
    "previewStates": {
      "live": "實際狀態",
      "present": "生效中",
      "seconds": "即將到期 · 4秒",
      "missing": "缺失",
      "unknown": "待確認"
    },
    "title": "BUFF管理",
    "subtitle": "把重要的狀態放在眼前，安心專注於冒險。",
    "add": "新增 BUFF提醒",
    "start": "開始監控",
    "stop": "停止監控",
    "openPip": "開啟畫中畫",
    "calibrationStates": {
      "waiting": "等待識別",
      "confirming": "正在定位",
      "located": "已定位",
      "missing": "暫未定位",
      "disabled": "未新增監控目標",
      "failed": "識別失敗",
      "cancelled": "已取消"
    },
    "locatedCount": "已識別 {count} / {total} 個",
    "control": {
      "title": "BUFF監控",
      "subtitle": "連線遊戲畫面後自動識別欄內的 BUFF。",
      "settings": "監控設定",
      "empty": "未配置",
      "emptyTitle": "還沒有需要監控的 BUFF",
      "emptyHint": "新增技能、藥水或其他狀態圖示，連線遊戲後會自動開始識別。",
      "waitingCapture": "等待遊戲畫面",
      "waiting": "等待識別",
      "preparing": "正在準備",
      "running": "監控中",
      "interrupted": "畫面待確認",
      "error": "識別異常",
      "disabled": "未新增目標",
      "seconds": "{value} 秒",
      "remindersHint": "預設規則會應用到所有 BUFF，也可以在單項設定中覆蓋。"
    },
    "myBuffs": "我的 BUFF",
    "enabledCount": "已新增 {count} 項",
    "emptyTitle": "先選幾個你關心的 BUFF",
    "emptyHint": "從小冊子選擇圖示，或新增自己的圖片。技能、藥水和其他狀態都可以。",
    "state": {
      "idle": "未開始",
      "preparing": "正在準備",
      "running": "監控中",
      "waiting": "等待確認 BUFF 欄",
      "interrupted": "畫面待確認",
      "error": "啟動失敗"
    },
    "present": "生效中",
    "missing": "缺失",
    "unknown": "待確認",
    "idle": "未開始",
    "disabled": "已停用",
    "seconds": "{value} 秒",
    "edit": "設定",
    "name": "名稱",
    "enabled": "啟用監控",
    "remove": "刪除",
    "undo": "撤銷刪除",
    "removed": "已刪除 {name}",
    "up": "上移",
    "down": "下移",
    "reorder": "拖動排序",
    "preview": "小工具預覽",
    "sample": "樣式預覽 · 示例狀態",
    "livePreview": "實時狀態",
    "appearance": "顯示設定",
    "mode": "顯示內容",
    "combined": "統計＋BUFF",
    "stats": "僅統計",
    "buffs": "僅 BUFF",
    "arrangement": "區域排列",
    "auto": "自動",
    "vertical": "上下排列",
    "horizontal": "左右排列",
    "reverse": "交換區域位置",
    "flow": "BUFF 排列",
    "wrap": "自動換行",
    "row": "橫條",
    "column": "豎列",
    "iconSize": "圖示大小",
    "gap": "圖示間距",
    "showNames": "顯示名稱",
    "hiddenCount": "還有 {count} 項，滾動檢視或放大視窗",
    "enlarge": "空間不足，請放大視窗",
    "noTargets": "請新增 BUFF",
    "manage": "返回 BUFF管理",
    "reminders": "統一提醒設定",
    "inherit": "使用統一提醒規則",
    "threshold": "提前提醒秒數",
    "visual": "視覺提醒",
    "speech": "語音提醒",
    "nearing": "即將到期",
    "priority": "播報優先順序",
    "summary": "提前 {seconds} 秒 · {voice}",
    "voiceOn": "語音開啟",
    "voiceOff": "語音關閉",
    "volume": "音量",
    "rate": "語速",
    "audition": "試聽",
    "speechError": "語音未能播放，請檢查瀏覽器或系統聲音設定",
    "online": "線上圖示",
    "local": "本地圖片",
    "search": "搜尋技能名稱或編號",
    "allJobs": "全部職業",
    "catalogHint": "這裡是技能圖示目錄，包含非 BUFF 技能。消耗品等圖片也可從本地新增。",
    "loading": "正在載入",
    "retry": "重試",
    "noResults": "沒有找到匹配的圖示",
    "added": "已新增",
    "selected": "已選擇 {count} 項",
    "addSelected": "新增所選 BUFF",
    "cancel": "取消",
    "done": "完成",
    "drop": "拖拽圖片到這裡，或複製圖片後貼上",
    "upload": "選擇圖片",
    "paste": "貼上圖片",
    "imageFormats": "PNG、JPEG、WebP · 每張最大 10 MB",
    "localOnly": "圖片僅儲存在當前瀏覽器，遊戲畫面僅在本機處理。",
    "crop": "裁切",
    "cropHint": "拖動框選要保留的圖示；不需要裁切時直接關閉。",
    "applyCrop": "應用裁切",
    "duplicate": "該圖片已新增",
    "importError": "圖片新增失敗",
    "clipboardEmpty": "剪貼簿中沒有可讀取的圖片，可以使用 Ctrl+V 貼上",
    "connectionError": "連線失敗",
    "catalogError": "暫時無法獲取圖示目錄",
    "imageError": "圖示下載失敗",
    "saveError": "本地儲存失敗，請檢查瀏覽器儲存空間",
    "detection": "檢測畫面與識別區域",
    "detectionHint": "自動定位覆蓋整行和多行 BUFF。框選是可選操作，不需要先施放技能。",
    "selectRegion": "手動框選",
    "autoRegion": "恢復自動定位",
    "regionHint": "在畫面上拖動，框住需要搜尋的 BUFF 區域。",
    "noCapture": "連線遊戲視窗後可以檢視畫面",
    "diagnostic": "匯出本地診斷",
    "diagnosticHint": "包含識別候選、實際展示值和耗時，不包含遊戲截圖，不自動上傳。",
    "clearDiagnostic": "清空診斷",
    "fpsLimited": "採集頻率調整失敗，識別響應可能變慢",
    "nearingNotice": "{name}即將結束",
    "exp": "經驗 / 小時",
    "more": "更多操作",
    "resetData": "BUFF 圖片、設定與上傳音訊也將清除"
  },
  "ocrQuality": {
    "manualEnhancement": "手動區域 · 通用增強",
    "preprocessRejected": "框選區域不符合目前識別來源，尚未送入 OCR。請框選完整數值，並保持屬性欄旁的標籤可見。",
    "worldsLevelPreprocessRejected": "未能確認完整的底欄等級，尚未送入 OCR。請框選完整等級數字並保留少量邊距；若包含 LV.，請保持標籤完整。",
    "lowConfidence": "上次讀到“{text}”，置信度 {confidence}，未達到 {minimumConfidence}。",
    "failed": "上次等級讀取未採用：{reason}。",
    "retrying": "正在重試，請保持遊戲畫面可見。",
    "minimumConfidence": "等級確認門檻",
    "attempt": "等級嘗試 {index}"
  },
  "firstUseCalibration": {
    "intro": "首次連線，正在自動識別遊戲介面。請保持角色狀態列可見；開啟道具欄可一併識別楓幣。",
    "skip": "跳過",
    "fallback": "未定位且沒有已有校準的專案保留預設設定，並繼續在後臺定位；定位完成前暫不顯示讀數。",
    "storageFailed": "首次識別狀態未能儲存，本次不會重複彈出；下次開啟可能再次自動識別。"
  },
  "capability": {
    "insecureContext": {
      "title": "當前頁面無法安全地使用採集和識別",
      "hint": "視窗共享和本地識別需要 HTTPS。請透過官網地址開啟楓記。",
      "action": "透過 HTTPS 開啟官網"
    },
    "embedded": {
      "title": "請在獨立標籤頁開啟楓記",
      "hint": "當前頁面處於內嵌框架中，視窗共享和小工具都無法可靠使用。",
      "action": "在獨立標籤頁開啟"
    },
    "mobile": {
      "title": "請用電腦瀏覽器開啟",
      "hint": "視窗採集可使用 Windows 桌面版 Microsoft Edge、Google Chrome 或 Firefox；置頂小工具需要 Microsoft Edge 或 Google Chrome。歷史記錄和排行榜仍可瀏覽。"
    },
    "unsupported": {
      "title": "當前瀏覽器無法採集遊戲視窗",
      "hint": "請複製頁面連結，使用電腦上的最新版 Microsoft Edge、Google Chrome 或 Firefox 開啟。"
    },
    "storage": {
      "title": "當前瀏覽器無法儲存本地記錄",
      "hint": "可能處於隱私模式或禁用了站點資料。歷史和校準無法儲存；排行榜仍可瀏覽。"
    },
    "simd": {
      "title": "當前瀏覽器無法執行本地識別",
      "hint": "缺少識別所需的 WASM SIMD。請改用最新版桌面 Edge、Chrome 或 Firefox，不必反覆下載資源。"
    },
    "popupHint": "當前瀏覽器不能把小工具置頂在遊戲上方，點選後會開啟普通視窗。直播仍可捕獲該視窗。",
    "popupBlocked": "瀏覽器攔截了獨立視窗。請允許本站彈出視窗後重試，或改用官方 Edge / Chrome。",
    "switchBrowser": "若持續異常，可改用最新版桌面 Microsoft Edge、Google Chrome 或 Firefox。"
  },
  "pip": {
    "chooseMode": "選擇小工具開啟方式",
    "modeUnavailable": "目前瀏覽器環境無法使用",
    "modes": {
      "pip": { "name": "子母畫面視窗", "hint": "置頂顯示，佔用瀏覽器子母畫面。" },
      "popup": { "name": "獨立視窗", "hint": "不佔用子母畫面，不會自動置頂。" }
    },
    "open": "開啟小工具",
    "opening": "正在開啟…",
    "dismiss": "收起",
    "retry": "重新開啟",
    "retryPopup": "開啟普通視窗",
    "copyLink": "複製頁面連結",
    "officialSite": "開啟正式站點",
    "newTab": "在新標籤頁開啟",
    "help": "檢視幫助",
    "diagnostics": "檢視診斷資訊",
    "copyDiagnostic": "複製診斷資訊",
    "copied": "已複製",
    "copyFailed": "未能自動複製，請選中下方文字手動複製。",
    "manualCopy": "可手動複製的內容",
    "selectWindow": "選擇遊戲視窗",
    "retryOcr": "重試識別",
    "dashboard": "仍可在控制面板檢視統計。",
    "captureFirst": "請先連線遊戲視窗並完成畫面識別，才能在控制面板檢視實時統計。",
    "helpText": "請回到當前頁面並點選“重新開啟”。若仍然失敗，可更新桌面版 Edge / Chrome，或檢查瀏覽器和組織的功能限制。",
    "popupBadge": "普通視窗",
    "popupHint": "無法置頂，將開啟普通視窗。直播仍可捕獲。",
    "popupHelp": "若彈窗被攔截，請允許本站彈出視窗後再試。需要蓋在遊戲上方時，請改用官方桌面 Edge 或 Chrome。",
    "refreshHint": "若重試後仍無法載入，請先結束當前記錄，再重新整理頁面。",
    "localDiagnostic": "僅包含瀏覽器、能力檢測和錯誤分類，保留在本次頁面執行中，不會自動上傳。",
    "insecure-context": {
      "title": "當前開啟方式無法使用小工具",
      "hint": "頁面不在安全上下文中，請透過 HTTPS 地址訪問楓記。"
    },
    "embedded": {
      "title": "請在獨立標籤頁開啟楓記",
      "hint": "當前頁面處於內嵌框架中，請在獨立瀏覽器標籤頁中開啟，再使用小工具。"
    },
    "unsupported": {
      "title": "當前瀏覽器環境無法開啟小工具",
      "hint": "請複製連結，使用電腦上的最新版 Microsoft Edge 或 Google Chrome 開啟。"
    },
    "not-connected": {
      "title": "請先連線遊戲視窗",
      "hint": "選擇正在執行的遊戲視窗，完成畫面識別後，再點選“開啟小工具”。"
    },
    "ocr-preparing": {
      "title": "正在準備畫面識別",
      "hint": "請等待畫面連線和識別準備完成，再點選“開啟小工具”。"
    },
    "ocr-error": {
      "title": "畫面識別尚未準備好",
      "hint": "識別準備未能完成，請重試識別後再開啟小工具。"
    },
    "ending": {
      "title": "正在完成記錄儲存",
      "hint": "記錄儲存完成後即可開啟小工具。"
    },
    "reloading": {
      "title": "正在準備重新整理頁面",
      "hint": "頁面重新整理完成後即可開啟小工具。"
    },
    "request-denied": {
      "title": "瀏覽器未允許本次開啟",
      "hint": "請回到當前頁面後點選“重新開啟”。若使用的是獨立視窗，請允許本站彈出視窗。",
      "fallbackTitle": "無法置頂小工具",
      "fallbackHint": "當前瀏覽器不能把小工具蓋在遊戲上方。點選下方按鈕即可開啟普通視窗，直播軟體仍能捕獲。"
    },
    "resource-load": {
      "title": "小工具內容未能載入",
      "hint": "請檢查網路連線，然後重試。"
    },
    "unknown": {
      "title": "小工具暫時無法開啟",
      "hint": "可以重新嘗試；若仍然失敗，請複製診斷資訊反饋。"
    }
  },
  "performance": {
    "buffCadence": "低／中檔在確認讀秒、臨期或狀態變化時，BUFF 會短暫提高至每 0.5 秒識別一次；倒計時持續更新。",
    "buffFrequency": "BUFF 識別",
    "help": {
      "entry": "卡頓解決方案",
      "title": "卡頓解決方案",
      "graphics": "關閉圖形加速",
      "systemLagTitle": "系統操作卡住了？",
      "systemLagIntro": "輸入法、電腦選單或 Alt+Tab 一起卡住時，常見於懸浮監控或桌面美化軟體衝突。",
      "conflictAction": "關閉衝突軟體",
      "conflictHint": "先退出微星小飛機、RivaTuner、Nexus 等，再重試。",
      "widgetAction": "關閉小工具或使用獨立視窗",
      "widgetHint": "先關閉小工具；需要使用時，點按鈕右側箭頭選擇「{mode}」。",
      "firefoxAction": "改用 Firefox（火狐）",
      "firefoxHint": "仍卡頓可用 Firefox 開啟本站；其小工具無法置頂，需選擇「{mode}」。",
      "browserTipsTitle": "網頁或辨識變慢？",
      "system": "{browser} · 系統設定",
      "webpages": "{browser} · 網頁設定",
      "firefox": "Firefox · 效能 → 取消推薦設定，再關閉硬體加速",
      "manual": "在瀏覽器設定中查詢圖形或硬體加速，若支援則關閉。",
      "copyLink": "複製地址",
      "copied": "已複製",
      "pasteHint": "貼上到位址列，關閉加速後重啟瀏覽器。",
      "copyFailed": "複製失敗，請手動複製上方地址。",
      "gameAcceleration": "關閉電腦遊戲加速",
      "gameAccelerationGuide": "{browser} · 效能設定",
      "gameAccelerationPaste": "貼上到位址列，關閉「電腦遊戲加速」後重啟瀏覽器。",
      "lower": "降低辨識負載",
      "currentTier": "當前：{tier} · 降檔可減輕負載",
      "lowerAction": "降低一檔",
      "lowest": "已是最低檔",
      "backgroundHint": "避免瀏覽器暫停背景記錄",
      "backgroundAction": "去設定"
    },
    "navigation": {
      "tier": "頻率詳情",
      "advanced": "高階設定",
      "diagnostics": "本地診斷"
    },
    "loadLevel": "識別負載",
    "frequencyOverview": "頻率總覽",
    "manualTuning": "手動微調",
    "localOnly": "僅本地",
    "title": "識別效能",
    "hint": "選擇適合裝置的檔位，統一調整採集、畫面檢查和各項讀取頻率。",
    "tiers": {
      "low": "低",
      "medium": "中",
      "default": "預設",
      "high": "高",
      "ultra": "超高"
    },
    "tierHints": {
      "low": "儘量減輕負載，資料更新會明顯變慢。",
      "medium": "較低負載，適合希望進一步節省資源的裝置。",
      "default": "採集與畫面檢查均為每秒一次，兼顧資源佔用與更新速度。",
      "high": "更密集的讀取機會，適合執行穩定、希望更新更及時的裝置。",
      "ultra": "最密集的讀取機會，負載更高，請根據裝置執行情況選擇。"
    },
    "tierDetails": "檢視檔位詳情",
    "advanced": "高階識別設定",
    "everySeconds": "每 {count} 秒 1 次",
    "demand": "按識別需求",
    "resetAdvanced": "恢復推薦值",
    "lessLoad": "更低負載",
    "fasterUpdates": "更新更及時",
    "recommended": "推薦",
    "captureShort": "螢幕採集",
    "processingShort": "畫面檢查",
    "detailHint": "檢視各項讀取頻率",
    "advancedHint": "嚴格度與畫面變化靈敏度",
    "diagnosticHint": "檢視執行表現，僅儲存在本地",
    "targetHint": "各項為目標間隔，實際讀取可能慢於目標頻率，受新畫面、OCR 耗時和指標排程影響。按識別需求的檢查間隔最快為 125 毫秒。",
    "pendingCapture": "識別設定已應用，採集頻率將在下次共享時生效。",
    "deferred": "正在完成起止取樣，完成後應用最新選擇；採集頻率在下次共享時生效。",
    "finalSampleIncomplete": "最終取樣未完成，記錄已保留此前確認的可信結果。",
    "captureLimit": "螢幕採集幀率上限",
    "captureHint": "下次選擇共享源時生效，不會中斷當前共享。實際幀率由瀏覽器和共享源決定。",
    "processingLimit": "畫面檢查頻率上限",
    "processingHint": "立即生效，限制常規畫面檢查。開始與結束記錄時的必要取樣不受此上限影響。",
    "defaultCapture": "預設（請求 10 幀/秒）",
    "defaultProcessing": "預設（按識別需求）",
    "fps": "{count} 幀/秒",
    "tradeoff": "降低上限可減少負載，但資料更新可能變慢，也可能錯過短暫的畫面變化。",
    "reportTitle": "本地診斷報告",
    "reportHint": "僅記錄本頁本次執行的耗時、頻率和錯誤分類；不包含截圖、OCR 原文或視窗標題，不會自動上傳。重新整理網頁後清空。",
    "refresh": "重新整理診斷",
    "copy": "複製診斷",
    "download": "下載 JSON",
    "clear": "清空診斷",
    "details": "檢視報告詳情",
    "reportedFps": "瀏覽器報告的採集幀率",
    "frameTime": "平均畫面處理耗時",
    "ocrTime": "平均 OCR 耗時",
    "resets": "OCR 引擎重置次數",
    "unavailable": "暫無資料",
    "milliseconds": "{count} 毫秒",
    "count": "{count} 次",
    "copied": "診斷已複製",
    "copyFailed": "複製失敗，請從報告詳情中手動複製。",
    "downloaded": "診斷已下載",
    "downloadFailed": "下載失敗，請嘗試複製診斷。",
    "cleared": "診斷已清空",
    "refreshed": "診斷已重新整理",
    "limitation": "報告中的幀率來自瀏覽器，耗時來自頁面測量；無法讀取 Windows 資源管理器、整機 CPU 或顯示卡佔用。最近耗時最多保留各階段 240 個樣本，錯誤保留最近 40 條。"
  },
  "stream": {
    "connect": {
      "entry": "接入直播",
      "title": "如何接入直播",
      "step1Title": "開啟小工具",
      "step1": "開啟後，拖動視窗邊緣調整大小。",
      "open": "開啟小工具",
      "opening": "正在開啟",
      "openFailed": "開啟失敗，請允許瀏覽器使用畫中畫後重試。",
      "unsupported": "請使用桌面版 Chrome 或 Edge 開啟小工具。",
      "step2Title": "選一個背景色",
      "step2": "選與文字、圖示不同的純色，方便直播工具去掉背景。",
      "copyColor": "複製色值",
      "copied": "已複製",
      "copyFailed": "複製失敗，請手動複製色值。",
      "solidNeeded": "當前背景帶有透明度，請選擇不透明的純色用於摳色。",
      "step3Title": "在直播工具中新增小工具",
      "capture": "新增“視窗捕獲”，選擇“楓記”小工具視窗。",
      "keyColor": "裁掉標題欄和底部操作欄，新增“色鍵”或“摳色”濾鏡，選中上面的背景色即可。",
      "note": "直播時保持主頁面和小工具開啟。",
      "done": "知道了"
    },
    "camp": "雪原遠征",
    "clockwork": "玩具城積木站",
    "pinkbean": "皮卡啾電臺",
    "kerning": "墮落城市塗鴉",
    "aqua": "深海潛航",
    "ellinia": "魔法森林·森間秘語",
    "orbis": "天空之城·雲上庭院",
    "temple": "時間神殿·時光迴廊",
    "zakum": "殘暴炎魔·熔岩祭壇",
    "skins": "外觀",
    "transparent": "透明（預設）",
    "white": "白色",
    "transparentShort": "透明",
    "charcoal": "深灰",
    "magentaShort": "洋紅",
    "greenShort": "綠色",
    "blueShort": "藍色",
    "hexColor": "十六進位制色值",
    "colorInvalid": "請輸入有效的 HEX 色值，如 #FFFFFF 或 #FFFFFF80。",
    "customColor": "自定義顏色",
    "opacity": "不透明度",
    "daily": "日常外觀",
    "title": "直播外觀",
    "classic": "冒險狀態列",
    "mushroom": "蘑菇夥伴",
    "minimal": "極簡戰報",
    "hint": "視窗縮小時先收起楓幣，再收起 BUFF，始終保留經驗效率。",
    "classicHint": "銀邊徽章 · 分段狀態條",
    "mushroomHint": "橙蘑菇夥伴 · 奶油色數值牌",
    "minimalHint": "描邊大字 · 無貫通底板",
    "preview": "佈局預覽",
    "strip": "橫條",
    "classicLayout": "普通",
    "portrait": "豎欄",
    "backgroundHelpLabel": "背景透明說明",
    "backgroundHelp": "透明只作用於網頁內容，瀏覽器仍會繪製畫中畫視窗的底色，因此無法直接透出後面的程式。接入直播時，請選擇純色背景，在直播工具中捕獲小工具視窗，再新增“色鍵”濾鏡摳除該顏色，即可透明疊加到直播畫面。",
    "background": "小工具背景",
    "magenta": "洋紅色鍵",
    "green": "綠色色鍵",
    "blue": "藍色色鍵",
    "solid": "深灰預覽底（不摳圖）",
    "motion": "遊戲動效",
    "motionHint": "輕微待機與升級慶祝，遵循系統減少動態效果設定。",
    "obs": "接入 OBS",
    "obsSteps": "新增「視窗捕獲」並選擇小工具 → 裁掉瀏覽器標題欄 → 新增「色鍵」濾鏡 → 選擇與小工具一致的鍵色。",
    "obsNote": "棋盤格表示透明區域。網頁透明背景不能保證畫中畫視窗透明；使用 OBS 捕獲時，建議選擇純色背景並新增色鍵濾鏡。",
    "obsColor": "洋紅色鍵：#FF00FF。使用自定義顏色，並微調相似度與平滑度，檢查藥水、圖示及文字邊緣是否完整。",
    "controls": "在小工具底部開始、暫停或結束記錄，直播時可裁掉操作欄。",
    "sample": "示例資料",
    "exp": "EXP / 小時",
    "mesos": "楓幣 / 小時",
    "level": "等級",
    "eta": "距升級",
    "gained": "淨",
    "net": "淨楓幣",
    "elapsed": "記錄時長",
    "start": "開始持有",
    "balance": "餘額變化",
    "full": "本級共需",
    "map": "地圖",
    "recording": "記錄中"
  },
  "captureRecovery": {
    "source-endedTitle": "共享已結束，請重新選擇目前的遊戲視窗",
    "source-endedHint": "關閉或重新開啟遊戲視窗後，需要重新選擇共享來源，無須重新整理網頁。切換帳號時，請先結束上一筆紀錄，再為新帳號開始紀錄。",
    "permission-deniedTitle": "未獲得視窗共享授權",
    "security-restrictedTitle": "視窗共享受到安全或許可權限制",
    "security-restrictedHint": "請檢查瀏覽器、系統或組織的共享許可權設定，然後重新選擇遊戲視窗。",
    "invalid-stateTitle": "請回到當前頁面重新選擇",
    "invalid-stateHint": "請切回當前頁面，並重新點選“選擇遊戲視窗”以發起共享。",
    "insecure-contextTitle": "當前頁面無法安全地發起共享",
    "insecure-contextHint": "視窗共享需要安全連線，請透過 HTTPS 開啟楓記官網後重試。",
    "embeddedTitle": "請在獨立標籤頁開啟楓記",
    "embeddedHint": "當前頁面處於內嵌框架中，請在獨立瀏覽器標籤頁中開啟後再共享視窗。",
    "mobileTitle": "請用電腦進行即時辨識",
    "mobileHint": "支援 Windows 版 Edge / Chrome / Firefox，手機可瀏覽歷史記錄和排行榜。",
    "mobileCopyLink": "複製連結",
    "policy-blockedTitle": "當前頁面不允許視窗共享",
    "policy-blockedHint": "請在獨立標籤頁開啟楓記後重試；若仍然失敗，請檢查瀏覽器或組織的共享限制。",
    "openOfficial": "透過 HTTPS 開啟官網",
    "openStandalone": "在獨立標籤頁開啟",
    "browserHelp": "瀏覽器升級與更換幫助",
    "updateSteps": "複製下面的地址，貼上到瀏覽器位址列並開啟，檢查 {browser} 更新；更新完成後重啟瀏覽器再試。",
    "updateMenu": "請透過瀏覽器選單中的“幫助”或“關於”檢查更新，或改用最新版桌面 Edge / Chrome / Firefox。",
    "copyUpdateAddress": "複製更新地址",
    "downloadEdge": "下載 Microsoft Edge",
    "downloadChrome": "下載 Google Chrome",
    "downloadFirefox": "下載 Firefox（火狐瀏覽器）",
    "copyPageLink": "複製當前頁面連結",
    "linkCopied": "地址已複製，請貼上到瀏覽器位址列開啟。",
    "linkCopyFailed": "自動複製失敗，請手動選擇並複製下方地址。",
    "manualAddress": "可手動複製的地址",
    "screenSteps": "點選下方按鈕，在瀏覽器共享彈窗中選擇「整個螢幕」，選中游戲所在的螢幕，再點選「共享」。",
    "tryScreen": "嘗試採集整個螢幕",
    "retryScreen": "重試整屏採集",
    "screenFailed": "整屏採集也未能啟動",
    "attemptFailed": "這次採集仍未啟動",
    "retryHint": "請先完全退出瀏覽器後重開，或改用最新版 Edge / Chrome / Firefox，再嘗試採集。",
    "screenHint": "請讓遊戲儘量鋪滿所選螢幕，並保持可見，避免最小化或被其他視窗遮擋。連線後檢查等級和經驗；識別不準確時，請調整識別區域。",
    "more": "更多排查方法",
    "windowMode": "將遊戲切換為視窗化或無邊框模式，並保持遊戲畫面可見。",
    "factoryReset": "到設定頁執行「恢復出廠設定」，然後重新連線畫面。",
    "updateBrowser": "將當前瀏覽器更新到最新版本。",
    "browser": "完全退出瀏覽器後重開，或改用最新版 Microsoft Edge / Google Chrome / Firefox。",
    "driver": "仍無法連線時，重啟電腦並更新顯示卡驅動和 Windows。若有錄屏、直播或遠端桌面正在執行，也可關閉後重試。",
    "compare": "可以選擇記事本等普通視窗作對照：只有遊戲失敗時，優先檢查遊戲顯示模式；所有來源都失敗時，優先檢查瀏覽器和系統。",
    "copy": "複製診斷資訊",
    "copied": "診斷資訊已複製",
    "copyFailed": "自動複製失敗，請手動選擇並複製下方診斷資訊。",
    "diagnostic": "採集診斷資訊"
  },
  "appUpdate": {
    "eyebrow": "楓記 · 版本更新",
    "title": "新版本已就緒",
    "hint": "重新整理即可體驗最新版本，也可以繼續使用，稍後再更新。",
    "preview": "外觀預覽 · 不會重新整理頁面",
    "previewFeedback": "僅預覽外觀，未執行任何更新",
    "previewClose": "預覽期間卡片保持顯示",
    "recordingHint": "更新會結束並儲存當前記錄，然後重新整理頁面。",
    "update": "重新整理更新",
    "endAndUpdate": "結束記錄並更新",
    "later": "稍後提醒",
    "close": "30 分鐘後再提醒",
    "available": "有更新",
    "saving": "正在儲存",
    "activating": "正在更新",
    "blocked": "請等待當前操作完成後再更新。",
    "saveError": "儲存未完成，頁面未重新整理。請重試以儲存資料並更新。",
    "activationError": "更新未完成，頁面未重新整理。請檢查網路後重試。",
    "retry": "重試更新"
  },
  "leaderboard": {
    "server": "伺服器",
    "mxdcServer": "國服懷舊服",
    "gcwServer": "GCW 國際服",
    "mapTip": {
      "details": "詳情",
      "openPage": "在新標籤頁檢視 {name} 的地圖資料",
      "open": "檢視 {name} 的地圖資料",
      "kind": "地圖",
      "loading": "正在載入地圖資料",
      "empty": "暫無地圖資料",
      "error": "地圖資料載入失敗，請重試",
      "monsterCount": "怪物數量",
      "npcCount": "NPC 數量",
      "monsters": "出沒怪物",
      "npcs": "出沒 NPC",
      "description": "地圖說明",
      "noNpcs": "暫無 NPC",
      "noMonsters": "暫無怪物",
      "more": "還有 {count} 條…",
      "image": "{name} 的小地圖",
      "noImage": "暫無小地圖預覽"
    },
    "title": "練級地圖排行",
    "levelRange": "{start}–{end} 級",
    "levelSample": "該行統計來自 {start}–{end} 級角色的記錄",
    "allLevels": "全部",
    "minutes": "{count} 分鐘",
    "sampleAccumulation": "同一玩家在同一地圖、等級段和資料來源下的多段記錄可累計形成樣本。查詢全部等級時，各等級段獨立計算和展示。",
    "level": "等級",
    "position": "排名",
    "status": "狀態",
    "collectingTab": "積累中",
    "formalTab": "正式榜",
    "sourceFilter": "來源",
    "hourlyExp": "經驗/小時",
    "hourlyReference": "參考經驗/小時",
    "records": "共 {count} 條",
    "sourceSamples": "資料來源",
    "allSourcesShort": "全部",
    "collapse": "收起詳情",
    "closeDetails": "收起 {name} 的詳情",
    "exp": "經驗效率",
    "perHour": "經驗 / 小時",
    "typical": "排行依據",
    "samples": "參與資料",
    "filters": "篩選",
    "filterTitle": "篩選地圖",
    "reset": "重置篩選",
    "done": "檢視結果",
    "search": "搜尋地圖",
    "searchPlaceholder": "搜尋地圖名稱或 ID",
    "searchClear": "清空搜尋",
    "filtersOpen": "開啟篩選",
    "filtersCount": "{count} 項已選",
    "removeFilter": "移除 {label}",
    "rules": "統計規則",
    "details": "地圖詳情",
    "openDetails": "檢視 {name} 的詳情",
    "scope": "{level} · {job} · {source}",
    "count": "{count} 張地圖",
    "page": "第 {current} / {total} 頁",
    "previous": "上一頁",
    "next": "下一頁",
    "goToPage": "轉到第 {page} 頁",
    "scale": "本頁效率對比",
    "sorted": "按中間水平排序",
    "collecting": "資料積累中",
    "moreUsers": "還差 {count} 位玩家",
    "moreMinutes": "還差 {count} 分鐘",
    "met": "已滿足",
    "usersProgress": "參與人數",
    "timeProgress": "有效時長",
    "sampleRule": "正式榜條件",
    "uploadRule": "楓記上傳條件",
    "uploadSourceRule": "必須使用視窗共享。每次共享僅檢查一次標題，明確不是“{title}”時，整條記錄不上傳；全屏無標題欄或標題未確認時預設允許。記錄一旦被排除，切換視窗或全屏不會恢復該條記錄的資格。本地統計和歷史儲存不受影響。",
    "sourceNotice": {
      "capture-not-window": "本次記錄不參與排行榜：必須使用視窗共享。本地統計照常；重新共享視窗並開始新記錄後可重新判斷。",
      "capture-title-mismatch": "本次記錄不參與排行榜：視窗標題不符合條件。本地統計照常；重新共享目標遊戲並開始新記錄後可重新判斷。"
    },
    "uploadEligibility": "同一地圖、同一等級段（每 5 級一檔），單段有效經驗記錄滿 {minutes} 分鐘且有經驗收益，即可上傳。不同片段不拼接湊時長。",
    "uploadTiming": "結束記錄後自動上傳達標片段。中途暫停或掉線，已達標的片段仍會保留。",
    "qualificationHelp": "資料不足的地圖會顯示在“積累中”。",
    "distribution": "不同玩家的經驗效率",
    "source": "資料來源",
    "updated": "最近更新",
    "median": "中間水平",
    "low": "較低水平",
    "high": "較高水平",
    "upper": "高效水平",
    "medianHelp": "按玩家每小時經驗的“中間水平”排名，只計入有效記錄。",
    "rangeHelp": "約一半玩家處於“較低水平”到“較高水平”之間。“高效水平”接近前 10%，不是最高紀錄。",
    "empty": "這裡還沒有地圖",
    "emptyHint": "試試搜尋地圖，或調整等級、職業、來源。",
    "gcwEmptyHint": "試試搜尋地圖，或調整等級。",
    "error": "暫時無法獲取排行",
    "refreshFailed": "更新失敗，保留上次結果。",
    "reference": "參考效率",
    "pending": "等待榜單更新",
    "back": "返回榜單",
    "closeDossier": "關閉地圖檔案",
    "dossier": "地圖檔案",
    "identity": "地圖",
    "efficiency": "練級效率",
    "trust": "樣本可信度",
    "monsters": "出沒怪物",
    "drops": "核心掉落",
    "equipment": "裝備",
    "scroll": "卷軸",
    "dropRateLabel": "爆率 {rate}，{tier}",
    "dropRateTier": {"high": "相對較高", "medium": "相對中等", "low": "相對較低", "neutral": ""},
    "dropRateValue": "掉落率 {rate}",
    "dropSources": "掉落來源",
    "allDropMonsters": "全部怪物",
    "dropMonsterFilter": "篩選掉落怪物",
    "unknownDropRate": "未知",
    "noDropSources": "暫無來源資料",
    "relativeDropRates": "顏色表示目前篩選內的相對掉落率。",
    "maxMonsterDropRate": "取本圖來源怪物的最高已知掉落率，不疊加角色掉落加成。",
    "noMonsters": "這張圖還沒有怪物資料",
    "noDrops": "這張圖還沒有核實掉落",
    "noMapDetail": "這張圖還沒有地圖檔案",
    "notes": "地圖說明",
    "loadingDetail": "正在載入地圖資料",
    "detailError": "地圖資料載入失敗",
    "openBooklet": "在小冊子檢視",
    "openBookletNamed": "在小冊子檢視 {name}",
    "spawn": "{count} 只",
    "monsterLevel": "Lv.{level}",
    "trustFormal": "{users} 位玩家 · {duration}",
    "trustUsersUnit": "位玩家",
    "hoursUnit": "小時",
    "collectingNeed": "還差 {users} 人 · {time}",
    "selectMap": "檢視 {name}",
    "moreFilters": "更多篩選",
    "partnership": "與小冊子聯動",
    "entityLoading": "正在載入資料",
    "entityEmpty": "暫無資料",
    "entityError": "資料載入失敗",
    "entityKind": {
      "mob": "怪物",
      "item": "道具"
    }
  },
  "app": {
    "name": "楓記",
    "tagline": "楓之谷經驗統計",
    "localOnly": "遊戲畫面僅本地處理",
    "currentPreset": "當前預設",
    "primaryNav": "主導航",
    "useDark": "切換到夜間模式",
    "useLight": "切換到日間模式",
    "language": "介面語言",
    "install": "安裝到裝置"
  },
  "startup": {
    "startingEngine": "正在啟動識別引擎",
    "windowSelectedStage": "遊戲視窗已選擇",
    "preparingRecognition": "正在準備識別",
    "confirmingGameType": "正在確認遊戲類型",
    "gameDetectionFailures": {
      "dimensions-changed": "遊戲視窗尺寸已變更，請保持視窗大小穩定後重試。",
      "profile-changed": "識別設定已變更，請重新啟動識別後重試。",
      "probe-error": "暫時無法確認遊戲類型，請保持遊戲畫面完整可見後重試。"
    },
    "timeoutTitle": "識別引擎啟動超時",
    "timeoutHint": "引擎響應超時，遊戲視窗連線仍保留，請嘗試重新啟動。",
    "sdkTimeoutHint": "識別程式載入超時。請重新啟動；如果仍然失敗，請重新整理頁面後重新選擇視窗。",
    "retryEngine": "重新啟動",
    "copyDiagnostic": "複製診斷資訊",
    "diagnosticCopied": "診斷資訊已複製",
    "diagnosticCopyFailed": "自動複製失敗，請手動複製下方診斷資訊。",
    "diagnosticLabel": "啟動診斷資訊",
    "stepWindow": "遊戲畫面接入",
    "stepWindowConnected": "已連線",
    "stepWindowConnecting": "連線中...",
    "stepWindowSelected": "已選擇視窗",
    "stepModel": "識別模型載入",
    "stepModelReady": "已就緒",
    "stepModelLoading": "載入中",
    "stepModelChecking": "檢查快取",
    "stepEngine": "本地引擎啟動",
    "stepEngineStarting": "初始化中...",
    "stepEngineReady": "已就緒",
    "title": "正在開啟畫面識別",
    "subtitle": "已連線遊戲視窗，正在配置本地識別引擎",
    "connectingSubtitle": "正在連線遊戲視窗畫面...",
    "initializingTitle": "正在開啟畫面識別",
    "initializingSubtitle": "已連線遊戲視窗，正在配置本地識別引擎",
    "windowSelected": "遊戲視窗已選擇",
    "windowConnected": "遊戲視窗已連線",
    "localProcessing": "純本地離線計算 · 畫面數據不離裝置",
    "engineLabel": "楓記畫面識別",
    "progress": "載入進度",
    "cacheChecking": "正在檢查瀏覽器中已有的識別資源",
    "cached": "已準備 {count}/2 項識別資源",
    "localHint": "所有畫面僅在本地記憶體中解析，不會上傳至任何伺服器",
    "initializingLocalHint": "所有畫面僅在本地記憶體中解析，不會上传至任何伺服器",
    "idle": "等待選擇視窗",
    "connectingFrame": "連線遊戲畫面",
    "checking": "檢查本地資源",
    "detection": "準備畫面定位",
    "recognition": "準備文字識別",
    "prepared": "識別資源已準備",
    "initializing": "啟動識別引擎",
    "ready": "準備完成",
    "phaseCheck": "檢查資源",
    "phaseRecognition": "準備識別",
    "phaseReady": "啟動完成",
    "errorTitle": "識別引擎準備失敗",
    "errorStatus": "準備未完成",
    "errorHint": "請稍後重試，已準備好的資源不會重複獲取。",
    "resourceErrorTitle": "識別資源下載失敗",
    "resourceErrorHint": "識別資源下載失敗，請檢查網路連線後重試。如果彈出了 IDM 下載視窗，請暫時停用瀏覽器中的 IDM Integration Module 擴充功能，再點擊「重新準備」。僅關閉 IDM 主程式可能無效。",
    "initializationErrorTitle": "識別引擎啟動失敗",
    "initializationErrorHint": "瀏覽器未能成功啟動識別引擎實例，請關閉高佔用網頁後重試。",
    "simdErrorTitle": "當前瀏覽器不支援本地高速識別",
    "simdErrorHint": "缺少識別所需的 WASM SIMD 支援，建議改用 Edge、Chrome 或 Firefox 瀏覽器。",
    "insecure-contextErrorTitle": "當前頁面無法安全地準備識別",
    "insecure-contextErrorHint": "本地識別需要 HTTPS，請透過官網地址開啟楓記後再連線遊戲視窗。",
    "unknownErrorTitle": "載入未完成",
    "unknownErrorHint": "啟動時遇到未知問題，請稍後重試。",
    "browserRecommendationTitle": "換個瀏覽器再試試",
    "browserRecommendationHint": "如果重新準備後仍然失敗，請嘗試使用最新版 Microsoft Edge、Google Chrome 或 Firefox 重新開啟楓記。",
    "fixesLabel": "還可以嘗試",
    "factoryResetFixTitle": "到設定頁恢復出廠設定",
    "factoryResetFixHint": "清除本機校準和偏好後，再重新準備識別。",
    "factoryResetFixAction": "前往設定",
    "updateBrowserFixTitle": "更新瀏覽器版本",
    "updateBrowserFixHint": "在瀏覽器中檢查更新，完成後重新開啟楓記。",
    "cacheDegradedWarning": "本次可正常使用，識別資源未能儲存，下次開啟可能需要重新載入。",
    "retry": "重新準備",
    "continue": "暫時關閉"
  },
  "nav": {
    "security": "安全性報告",
    "securityBadge": "公開",
    "securityShort": "安全",
    "dashboard": "控制面板",
    "live": "實時記錄",
    "calibration": "識別校準",
    "history": "歷史記錄",
    "rank": "地圖排行榜",
    "rankShort": "地圖排行",
    "rankPartner": "與小冊子聯動",
    "settings": "設定",
    "changelog": "更新日誌",
    "about": "關於"
  },
  "common": {
    "unavailable": "暫無",
    "save": "儲存",
    "cancel": "取消",
    "reset": "恢復預設",
    "close": "關閉",
    "retry": "重試",
    "unknown": "未知",
    "confirm": "確認"
  },
  "journey": {
    "efficiency": "階段效率",
    "recentEfficiency": "近 5 分鐘",
    "pathSummary": "關鍵節點",
    "pathValue": "升級 {levels} 次 · 地圖 {maps} 張",
    "summaryLabel": "階段效率摘要",
    "level": "等級",
    "expProgress": "當前經驗",
    "map": "所在地圖",
    "approximate": "跨級約值",
    "confirmedPoint": "確認端點",
    "awaitingReading": "等待新的精確讀數",
    "approximateHint": "跨級經驗使用本次記錄中推算出的等級經驗",
    "confirmedHint": "來自已驗證的精確經驗讀數",
    "efficiencyChartLabel": "按真實時間展示的階段效率圖",
    "eventsLabel": "關鍵節點",
    "eventLevelUp": "升至 Lv.{level}",
    "eventMapChange": "進入 {map}",
    "mapChanged": "地圖變化",
    "minuteShort": "分",
    "hourShort": "時",
    "perHourShort": "/小時",
    "chartControls": "趨勢圖操作",
    "selectRange": "框選放大",
    "panChart": "平移時間範圍",
    "zoomIn": "放大",
    "zoomOut": "縮小",
    "resetZoom": "恢復全覽",
    "earlier": "檢視更早時段",
    "later": "檢視更晚時段",
    "eventGroup": "{time} · {count} 個節點",
    "event": {
      "pause": "暫停記錄",
      "resume": "繼續記錄",
      "capture-interrupted": "畫面中斷",
      "capture-restored": "畫面恢復",
      "rebaseline": "經驗讀數重新校準"
    }
  },
  "presets": {
    "worlds": { "name": "冒險島世界", "description": "冒險島世界繁體中文介面" },
    "label": "遊戲預設",
    "auto": "自動識別（經典 / Artale）",
    "gcw": { "name": "GCW", "description": "國際服懷舊服英文介面" },
    "artale": {
      "name": "Artale",
      "description": "Artale 繁體中文介面"
    },
    "ambiguous": "畫面中出現多個遊戲介面，請只保留一個遊戲視窗後重新自動識別。",
    "mxdc": {
      "name": "中國服懷舊服",
      "description": "中國服懷舊服介面"
    }
  },
  "live": {
    "mesosLocate": {
      "inventoryOpen": "已開啟道具欄？",
      "start": "自動識別",
      "retry": "重新識別",
      "retrySave": "重試儲存",
      "recognizing": "識別中…",
      "saving": "正在儲存…",
      "locating": "請保持道具欄和楓幣區域可見。",
      "located": "已找到楓幣區域，正在讀取餘額。",
      "missing": "未識別到楓幣，請開啟道具欄並保持楓幣區域可見後重試。",
      "timeout": "識別超時，請保持遊戲畫面可見後重試。",
      "saveFailed": "楓幣位置儲存失敗，請重試。",
      "failed": "楓幣識別暫不可用，請稍後重試。",
      "interrupted": "遊戲畫面或識別設定已變化，請重新識別。",
      "disconnected": "請先連線遊戲視窗，並開啟道具欄以讀取楓幣餘額。",
      "connecting": "正在連線遊戲畫面，連線後即可識別。",
      "preparing": "正在準備畫面識別，準備完成後即可操作。",
      "engineError": "畫面識別暫不可用，請按頁面提示重試。",
      "otherCalibration": "其他識別校準正在進行，請稍後重試。",
      "unavailable": "正在處理記錄或設定，請稍後重試。"
    },
    "expNetGain": "經驗淨",
    "expNetShort": "淨",
    "empty": {
      "expPreviewHint": "開始記錄後，顯示平均效率、即時速率和升級預估。",
      "expTitle": "經驗資料",
      "expHint": "連線後顯示經驗進度，開始記錄後計算升級效率。",
      "expConnectedHint": "保持等級與經驗區域可見，讀取後將在這裡顯示。",
      "mesosTitle": "楓幣資料",
      "mesosHint": "連線遊戲並開啟道具欄後，顯示楓幣餘額。",
      "mesosConnectedHint": "請開啟道具欄，並保持楓幣區域可見。",
      "resourcesTitle": "角色狀態",
      "resourcesHint": "連線遊戲後，顯示生命與魔法狀態。",
      "resourcesConnectedHint": "保持 HP / MP 區域可見，讀取後自動顯示。",
      "resourcesLabel": "HP / MP · BUFF提醒",
      "reading": "待讀取",
      "maximum": "上限 {value}",
      "startToCalculate": "開始記錄後計算",
      "waitingRate": "暫無效率資料",
      "cannotEstimate": "暫無法估算",
      "connecting": "正在連線遊戲畫面，連線後自動讀取資料。",
      "preparing": "正在準備畫面識別，準備完成後自動讀取。",
      "readingError": "畫面識別暫不可用，請按頁面提示重試。",
      "reconnect": "遊戲畫面暫不可用，請按上方提示重新連線。",
      "trendTitle": "升級效率趨勢圖",
      "trendHint": "開始記錄後，在這裡檢視階段效率變化。",
      "trendPending": "正在積累趨勢資料",
      "trendPendingHint": "有可用的階段資料後，趨勢會顯示在這裡。",
      "diagnosticsTitle": "連線遊戲後檢視",
      "diagnosticsHint": "連線後，在這裡檢視畫面讀取與資料更新狀態。"
    },
    "title": "控制面板",
    "subtitle": "記錄本次升級效率，遊戲畫面僅在當前裝置處理",
    "selectWindow": "選擇遊戲視窗",
    "captureIdle": "等待連線遊戲視窗",
    "captureHint": "點選後，瀏覽器會讓你選擇正在執行的楓之谷視窗。",
    "firstStep": "第一步",
    "onboardingTitle": "先選擇楓之谷視窗",
    "onboardingHint": "楓記只會讀取你主動選擇的視窗，連線後即可確認資料並開始記錄。",
    "gettingStarted": "開始使用",
    "guideWindow": "選擇遊戲視窗",
    "guideCheck": "需要時校準",
    "guideRecord": "開始記錄",
    "calibrationShortcut": "校準識別區域",
    "calibrationShort": "校準",
    "capturePermissionDenied": "未獲得視窗共享授權。請重新選擇遊戲視窗。若沒有看到共享彈窗，請確認瀏覽器未攔截提示。",
    "captureSourceUnavailable": "所選畫面未能啟動，請在下方嘗試其他採集方式。",
    "captureTimeout": "連線遊戲畫面超時，請保持遊戲視窗可見後重新選擇。",
    "captureUnsupported": "當前瀏覽器無法進行視窗採集，請使用最新版 Edge、Chrome 或 Firefox。",
    "captureFailed": "暫時無法連線遊戲視窗，請重新選擇後再試。",
    "captureRequesting": "正在連線",
    "captureSelecting": "正在選擇來源",
    "captureConnecting": "正在連線畫面",
    "captureSelectingTitle": "請在瀏覽器彈窗中選擇要共享的畫面",
    "captureConnectingTitle": "正在連線所選畫面",
    "captureRetryWindow": "重新選擇視窗",
    "captureSelectionSlow": "本次選擇或連線畫面用時較長。若共享彈窗卡頓，請關閉錄屏、直播和遠端桌面，減少開啟的視窗，並更新瀏覽器與顯示卡驅動。",
    "captureIssueSourceTitle": "遊戲畫面未能啟動",
    "captureIssueSourceHint": "瀏覽器未能啟動所選畫面，可以嘗試採集整個螢幕。",
    "captureIssueTimeoutTitle": "連線遊戲畫面超時",
    "captureIssueTimeoutHint": "瀏覽器沒有及時收到所選畫面。請保持遊戲可見，也可以嘗試採集整個螢幕。",
    "captureIssueUnsupportedTitle": "當前瀏覽器不支援視窗採集",
    "captureIssueUnsupportedHint": "請使用最新版 Microsoft Edge、Google Chrome 或 Firefox 開啟楓記。",
    "captureIssueUnknownTitle": "暫時無法連線遊戲視窗",
    "captureIssueUnknownHint": "請重新選擇遊戲視窗；若仍然失敗，可以嘗試下面的恢復方法。",
    "captureRecoveryMore": "仍無法連線時，請減少開啟的視窗並更新瀏覽器與顯示卡驅動；也可完全退出瀏覽器，按 Win + Ctrl + Shift + B 重啟顯示卡驅動，或改用最新版 Edge / Chrome / Firefox。",
    "captureActive": "視窗已連線",
    "captureInterrupted": "捕獲已中斷",
    "start": "開始記錄",
    "pause": "暫停",
    "resume": "繼續",
    "end": "結束",
    "ending": "正在結束",
    "startConfirming": "正在確認經驗",
    "startBaselineFailed": "未能確認當前等級和經驗，請檢查經驗區域是否完整可見後重試。",
    "startBaselineSlow": "識別響應較慢，請保持遊戲畫面可見後重試。",
    "startBaselineConfirming": "等級與經驗仍在確認，請保持畫面穩定後重試。",
    "startBaselineIncomplete": "完整經驗值未確認，請確保經驗數字和百分比完整可見後重試。",
    "startBaselineCaptureUnavailable": "遊戲畫面已中斷，請重新選擇遊戲視窗後重試。",
    "startWaitingFrame": "正在等待下一幀",
    "startRecognizing": "正在識別等級和經驗",
    "startFrameSlowTitle": "遊戲畫面更新較慢",
    "startFrameSlowHint": "超過當前取樣節奏的預期等待時間，仍未收到新畫面。請保持共享視窗可見，也可以取消後重試。",
    "startIssue": {
      "waitingEyebrow": "正在準備記錄",
      "confirmationLabel": "{metric}確認",
      "eyebrow": "開始記錄前需要處理",
      "levelTitle": "未能確認當前等級",
      "expTitle": "未能確認完整經驗",
      "slowTitle": "識別響應較慢",
      "slowWaitingTitle": "裝置識別較慢，正在繼續確認",
      "slowWaitingReason": "正在等待可靠的經驗起點，確認前不會計時。等級等資訊可稍後補齊，無需重複點選開始。",
      "expOneMore": "經驗已識別，還需一次確認（1/2）。請保持遊戲畫面可見。",
      "confirmationProgress": "{metric}確認：{confirmed} / {target}",
      "details": "識別詳情",
      "refreshDetails": "重新整理詳情",
      "noSnapshot": "暫無識別截圖，可稍後重新整理詳情。",
      "expProgressRetained": "已保留一次完整經驗確認（1/2），還需另一來源影格的完整讀數。",
      "engineTitle": "經驗識別暫不可用",
      "captureTitle": "遊戲畫面已中斷",
      "detectedText": "本次 OCR 原文",
      "levelConfirming": "已識別到等級 {candidate}，但尚未取得第二次獨立確認。",
      "reasons": {
        "no-text": "實際讀取區域中沒有檢測到文字，請檢查框選位置和遊戲介面可見性。",
        "parse-failed": "檢測到了文字，但無法解析為有效的{metric}資料。",
        "low-confidence": "已檢測到{metric}文字，但識別質量尚未達到嚴格確認標準。",
        "mixed-content": "框內包含 LV 之外的數字或干擾內容，程式無法唯一確認等級。",
        "confirming": "已讀取到{metric}候選值，但尚未完成獨立樣本確認。",
        "incomplete": "EXP 的絕對值或百分比不完整，當前讀數不能作為準確起點。",
        "conflict": "EXP 數字、百分比與同畫面經驗條無法互相驗證。",
        "slow": "尚未取得新的可信等級和經驗，識別引擎仍在處理較慢的畫面。",
        "unresponsive": "等待專用確認無進展，識別任務仍未返回。請保持遊戲畫面可見後重試。",
        "engine-error": "經驗識別出錯，確認已停止。請重試；若仍失敗，請重新連接遊戲視窗。",
        "capture-unavailable": "視窗授權或遊戲畫面已中斷，無法取得本次記錄的準確起點。"
      },
      "reviewFailure": {
        "no-text": "最近一次複核沒有檢測到文字，已識別的等級候選仍然保留。",
        "parse-failed": "最近一次複核未能解析出有效等級，已識別的等級候選仍然保留。",
        "low-confidence": "最近一次複核的識別質量不足，已識別的等級候選仍然保留。"
      },
      "path": {
        "legacy": "本次使用原識別區域",
        "adaptive": "本次使用自動適配區域"
      },
      "guidance": {
        "level": "框住完整等級數字及少量邊緣（橙色徽章或黑底黃色數字），勿切掉數字或徽章邊界；不要包含暱稱、職業或其他數字。",
        "exp": "框住完整 EXP 數字與百分比文字行；無需包含下方黃色經驗條。"
      },
      "adjust": {
        "level": "調整等級區域",
        "exp": "調整 EXP 區域"
      },
      "chooseWindow": "重新選擇視窗",
      "retry": "重新識別",
      "cancel": "取消確認",
      "later": "稍後處理"
    },
    "pip": "開啟小工具",
    "pipUnsupported": "當前瀏覽器不支援畫中畫小工具",
    "elapsed": "記錄時長",
    "expRate": "EXP / 小時",
    "mesosRate": "楓幣 / 小時",
    "level": "等級",
    "exp": "經驗值",
    "mesos": "楓幣",
    "hp": "HP",
    "mp": "MP",
    "mapName": "當前地圖",
    "jobName": "職業",
    "mapPending": "識別中",
    "mapUncertain": "暫無法確認地圖",
    "mapConfirming": "地圖待確認",
    "currentRecord": "本次記錄",
    "recentTrend": "升級效率趨勢",
    "levelPending": "等級資料",
    "coverageShort": "有效識別",
    "coverageHint": "從本次記錄的第一條可信資料開始計算；未讀取到資料和複用快取不計入，透過校驗的更新越穩定，比例越高",
    "expProgress": "當前經驗",
    "startExp": "開始經驗",
    "startLevel": "開始等級 Lv.{level}",
    "remainingExp": "距離下一級",
    "levelEta": "預計升級",
    "fullLevelDuration": "本級共需多久升級",
    "expGained": "本次獲得",
    "startSummary": "起始 Lv.{level} · {exp} EXP",
    "expConfirmationFailure": {
      "invalid-exp-range": "已讀取到 EXP 數字和百分比，但本次讀數未透過一致性校驗，不能計入確認。",
      "incompatible-exp-samples": "前後兩次 EXP 讀數未能互相驗證，需要再次確認。"
    },
    "readyToLevel": "即將升級",
    "lessThanMinute": "不足 1 分鐘",
    "estimateMinutes": "{count} 分鐘",
    "estimateHours": "{hours} 小時 {minutes} 分",
    "estimateDays": "{days} 天 {hours} 小時",
    "inventoryRecognition": "餘額與收益",
    "startMesos": "開始持有",
    "currentMesos": "當前持有",
    "balanceMesos": "餘額變化",
    "netMesos": "本次淨變化",
    "showBalanceComparison": "顯示開始持有和餘額變化",
    "showTrackedMesos": "顯示當前持有和本次淨變化",
    "disableRecognition": "不識別",
    "disableMetricRecognition": "停止識別{metric}",
    "restoreDefaultRecognition": "恢復識別",
    "hideCard": "隱藏卡片",
    "mesosUnavailableHint": "請開啟道具欄並保持楓幣區域可見；首次可信餘額會記錄為“開始持有”。",
    "mesosAvailableHint": "“本次淨變化”只累計道具欄可見期間確認的變化，可能與當前持有減開始持有的結果不同。",
    "resourceStatus": "實時狀態",
    "noData": "開始記錄後，階段效率會顯示在這裡。",
    "trendChartLabel": "本次記錄的階段效率",
    "modelReady": "畫面讀取已準備好。",
    "modelLoading": "正在準備畫面讀取。",
    "modelError": "畫面讀取暫不可用，請重新載入。",
    "diagnostics": "執行狀態",
    "located": "位置正常",
    "presetPosition": "使用預設位置",
    "processingLatency": "更新速度",
    "retrying": "等待重試",
    "onDemand": "隨畫面更新",
    "gameLayout": "資料位置",
    "dataRefresh": "資料更新",
    "textReading": "文字讀取",
    "windowConnection": "遊戲視窗",
    "refreshWaiting": "等待畫面",
    "refreshSmooth": "流暢",
    "refreshNormal": "正常",
    "refreshSlow": "稍慢",
    "ready": "已就緒",
    "preparing": "準備中",
    "ocrWaitingForWindow": "連線視窗後啟動",
    "unavailable": "暫不可用",
    "connected": "已連線",
    "notConnected": "未連線",
    "status": {
      "ending": "結束中",
      "idle": "尚未開始",
      "running": "記錄中",
      "paused": "已暫停",
      "ended": "已結束",
      "interrupted": "連線中斷"
    }
  },
  "calibration": {
    "pendingRawText": "尚未完成本次識別",
    "ocrInputPreview": "實際識別輸入",
    "liveRegionPreview": "即時選區預覽",
    "waitingFrame": "等待新畫面",
    "mesosQueued": "等待 OCR",
    "taskScheduled": "任務開始時間",
    "taskCompleted": "任務完成時間",
    "completedStatus": "最近完成結果",
    "autoLocate": "自動識別",
    "autoDialog": {
      "details": "定位診斷",
      "download": "下載採集原圖",
      "copy": "複製診斷資訊",
      "copied": "診斷資訊已複製",
      "exportFailed": "匯出失敗，請重試。",
      "capture": "採集尺寸",
      "scale": "介面縮放",
      "duration": "定位耗時",
      "confirmation": "確認方式",
      "confirmations": {
        "source-frames": "不同來源幀",
        "static-structure": "靜態畫面結構驗證"
      },
      "reasons": {
        "timeout": "本次識別已超時，請重試。",
        "not-found": "未找到介面結構，請顯示完整遊戲畫面。",
        "too-small": "畫面過小或不清晰，請放大遊戲畫面。",
        "occluded": "區域缺少完整結構，可能被遮擋。",
        "multiple-scenes": "存在多個遊戲畫面，請縮小採集範圍。",
        "unconfirmed": "已發現候選，但尚未完成確認。",
        "capture-interrupted": "採集已中斷，請恢復採集後重試。"
      },
      "stages": {
        "preparing": "準備中",
        "locating": "正在定位",
        "saving": "正在儲存",
        "ended": "執行結束"
      },
      "count": "已定位 {count}/{total}",
      "items": {
        "waiting": "等待定位",
        "confirming": "正在確認",
        "located": "已定位",
        "saved": "已儲存",
        "missing": "未定位"
      },
      "mesosMissing": "未識別到楓幣，請開啟道具欄，保持楓幣區域可見後重試。",
      "retryMesos": "重試楓幣",
      "recognizing": "識別中…",
      "keepInventoryVisible": "請保持道具欄和楓幣區域可見。",
      "retained": "保留原位置",
      "cancel": "取消",
      "done": "完成",
      "retry": "重新識別全部",
      "retrySave": "重試儲存",
      "keepVisible": "請保持遊戲畫面可見，正在確認各項位置。",
      "outcomes": {
        "complete": "已定位並儲存全部 {total} 項位置。",
        "partial": "已儲存 {count} 項位置，未定位的專案可重試。",
        "failed": "無法完成定位，請保持採集畫面可見後重試。",
        "saveFailed": "位置已找到，但未儲存。請重試儲存。",
        "cancelled": "已取消本次定位，原有位置未被替換。"
      }
    },
    "resetAllConfirmTitle": "恢復全部預設位置",
    "resetAllConfirmMessage": "將恢復全部 7 項的預設位置，現有手動調整會被清除。是否繼續？",
    "resetAllConfirm": "確認恢復",
    "resetAllCancel": "取消",
    "resetAllSuccess": "已恢復全部 7 項的預設位置。",
    "recognitionResult": "識別結果",
    "emptyRawText": "暫未讀到文字",
    "awaitingRegionRawText": "等待區域驗證後辨識",
    "expandRawText": "展開原文",
    "collapseRawText": "收起原文",
    "regionPreview": "區域預覽",
    "recognitionDetails": "識別詳情",
    "resultStates": {
      "waiting": "等待識別",
      "preparing": "正在準備識別",
      "restoring": "正在恢復預設",
      "disconnected": "等待採集畫面",
      "disabled": "已關閉識別",
      "running": "正在更新",
      "confirming": "正在確認",
      "success": "識別成功",
      "partial": "部分識別",
      "failed": "暫未識別成功",
      "hidden": "楓幣區域不可見",
      "engineError": "識別暫不可用"
    },
    "resultLabels": {
      "current": "本次結果",
      "candidate": "待確認結果",
      "previous": "上次識別結果"
    },
    "resultHints": {
      "mapTextClipped": "地圖文字可能被識別框截斷，請框入完整名稱並保留少量留白。",
      "mapSuffixUncertain": "末尾編號仍不清晰，暫無法確認；請檢查完整編號是否清晰可見，程式將自動重試。",
      "mapUncertain": "暫無法確認完整地圖名稱，將自動重試；如有上次確認結果會暫時保留。",
      "mapSuffixClipped": "地圖編號可能被識別框截斷，請將完整名稱和末尾編號框入。",
      "mapSuffixPending": "地圖編號尚未確認，正在複核；如有上次確認結果會暫時保留。",
      "layoutUnavailable": "缺少有效的介面定位，正在重新定位，請保持遊戲介面可見。",
      "resourceBarConflict": "文字數值與血條比例不一致，完整數值暫未採用。",
      "newPosition": "位置已調整，正在等待新位置的識別結果。",
      "locating": "正在定位識別區域，請保持遊戲畫面可見。",
      "openInventory": "請開啟道具欄，保持楓幣區域可見。",
      "inventoryUnconfirmed": "暫時無法確認楓幣欄，正在重新定位，請保持道具欄完整可見。",
      "noText": "未檢測到文字，請將識別框對準需要讀取的內容。",
      "parseFailed": "文字無法解析，請縮小識別框，避免框入其他內容。",
      "lowConfidence": "文字不夠清晰，請檢查識別框和遊戲畫面。",
      "noResult": "暫未讀到結果，請保持識別區域清晰可見。",
      "partial": "已讀到部分資訊，完整數字尚未確認。",
      "estimated": "當前為估算結果，正在等待精確數字。",
      "engineError": "識別引擎未就緒，請回到控制面板檢查識別資源。"
    },
    "statisticsReview": "統計校驗",
    "statisticsReason": "統計校驗說明",
    "mapConfirmationReason": "複核說明",
    "statisticsStates": {
      "accepted": "已透過統計校驗",
      "pending": "統計仍在複核",
      "rejected": "本次未採用"
    },
    "initialize": "全部恢復預設",
    "initializing": "正在恢復…",
    "restoreMetricHint": "僅恢復{metric}的預設位置",
    "initializingHint": "正在確認各項位置，請保持遊戲畫面可見。",
    "initializeComplete": "全部 7 項位置已恢復預設並儲存。",
    "initializePartial": "已定位並儲存 {count} 項；{metrics} 未定位，本版已有位置已保留。請顯示完整介面後重試。",
    "initializeFailed": "恢復預設或儲存未完成，請保持採集畫面可見後重試。",
    "mapConfirmationWait": "複核等待",
    "mapConfirmationSeconds": "{count} 秒",
    "mapConfirmationMethod": "確認方式",
    "mapConfirmationModes": {
      "independent-frames": "兩幀獨立畫面複核",
      "suffix-frames": "編號字形與獨立畫面一致",
      "cross-variant": "不同方案一致",
      "stable-variant": "連續穩定識別"
    },
    "mapConfirmationReasons": {
      "suffix-ambiguous": "地圖編號不清晰，等待新的畫面複核",
      "suffix-clipped": "地圖編號可能被識別框截斷，請檢查選區",
      "collecting": "等待更多獨立畫面複核",
      "conflict": "不同方案結果不一致，正在比較穩定性",
      "unstable": "本輪沒有足夠穩定的結果，將稍後重試",
      "expired": "本輪複核已超時，暫無法確認，將自動重試"
    },
    "title": "識別校準",
    "subtitle": "框選需要讀取的位置，調整後會自動儲存在當前瀏覽器",
    "noCapture": "請先回到控制面板選擇遊戲視窗",
    "expCreditedDelta": "本次可信計入經驗",
    "expThreshold": "可信增量上限",
    "expDisplayValue": "展示採用經驗",
    "expDisplayGain": "展示淨收益",
    "expDisplayStatus": "展示計算狀態",
    "expDisplayStates": {
      "ready": "可計算",
      "stale": "等待最新讀數",
      "pending-transition": "待確認",
      "unresolved-level": "經驗資料不完整",
      "unavailable": "尚無完整讀數"
    },
    "expAdmissionReasons": {
      "large-gain": "增量超限，異常缺口不計入",
      "level-correction": "等級校正，未確認升級",
      "decrease": "經驗下降，重新確認起點",
      "requirement-conflict": "經驗需求範圍衝突",
      "recovery": "恢復後確認中",
      "invalid": "經驗資料無效",
      "stale": "重複或過期樣本"
    },
    "goLive": "返回控制面板",
    "autoLocated": "已自動找到",
    "fallback": "使用預設位置",
    "confidence": "識別質量",
    "selectedRoi": "識別專案",
    "preview": "讀取預覽",
    "latestRecognition": "本次識別",
    "statisticsValue": "統計採用值",
    "confirmationProgress": "複核中 {current}/{target}",
    "rawText": "OCR 原文",
    "barRatio": "當前比例",
    "readingStatus": "讀取狀態",
    "lastAttempt": "最後嘗試",
    "inferenceDuration": "推理耗時",
    "durationValue": "{value} 毫秒",
    "enhancement": "增強方案",
    "enhancementValue": "方案 {index}",
    "levelEnhancements": {
      "color-smooth": "彩色 · 平滑",
      "color-pixelated": "彩色 · 最近鄰",
      "luminance-inverted": "灰度反色 · 平滑",
      "luminance-smooth": "亮度灰度 · 平滑",
      "luminance-pixelated": "亮度灰度 · 最近鄰"
    },
    "failureReasonLabel": "未採用原因",
    "levelCorrected": "已透過連續讀取確認等級",
    "profile": "當前畫面",
    "saved": "校準已儲存",
    "strategy": "讀取方式",
    "sourcePreview": "原始畫面",
    "processedPreview": "增強畫面",
    "captureInfo": "畫面資訊",
    "help": "拖動文字框可移動，拖動右下角可縮放。HP、MP 和經驗的顏色條由程式按定位結果自動校驗，不必框進文字範圍。",
    "required": "預設已更新，請重新確認識別區域；當前設定會自動儲存。",
    "recommendedHint": "虛線是文字讀取範圍；細實線是自動校驗的顏色條，不會送入 OCR。",
    "adjustedHint": "文字範圍已調整並自動儲存。",
    "restoreDefault": "恢復預設",
    "startGuidanceTitle": "請修正本次開始失敗的識別區域",
    "startGuidance": {
      "level": "等級尚未可靠確認。請按下方示例調整虛線文字範圍，完成後保持畫面穩定，等待兩次獨立讀取確認。",
      "exp": "完整 EXP 尚未可靠確認。請按下方示例框住 EXP、當前經驗和百分比；黃色經驗條由程式自動校驗。"
    },
    "resize": "調整識別區域大小",
    "roiLabel": "當前識別區域",
    "overrides": "{count} 項自定義區域",
    "positioning": "位置狀態",
    "customPosition": "使用者已調整",
    "automaticPosition": "推薦範圍",
    "adaptiveSearching": "正在適配",
    "adaptiveReady": "已自動收緊",
    "adaptiveFallback": "使用搜尋範圍",
    "searchRange": "搜尋範圍",
    "actualTextRange": "文字讀取",
    "actualBarRange": "顏色條讀取",
    "framingGuide": "框選示例",
    "include": "應包含",
    "exclude": "不要包含",
    "guideSamples": {
      "nickname": "角色暱稱",
      "job": "職業名稱",
      "jobValue": "刺客",
      "minimap": "小地圖",
      "mapName": "黑森林狩獵場",
      "quest": "任務文字"
    },
    "guide": {
      "level": {
        "title": "只讀取 LV 和等級數字",
        "include": "完整等級數字（橙色徽章或黑底黃字）及少量邊緣",
        "exclude": "暱稱、職業、家族及其他數字"
      },
      "exp": {
        "title": "只框 EXP 文字行",
        "include": "EXP、當前經驗和百分比",
        "exclude": "下方黃色經驗條、等級、HP、MP 和相鄰文字"
      },
      "hp": {
        "title": "只框 HP 數字行",
        "include": "HP 標籤與當前值/最大值",
        "exclude": "下方紅色條、MP、EXP 或相鄰狀態文字"
      },
      "mp": {
        "title": "只框 MP 數字行",
        "include": "MP 標籤與當前值/最大值",
        "exclude": "下方藍色條、HP、EXP 或相鄰狀態文字"
      },
      "mesos": {
        "title": "讀取楓幣行的完整餘額",
        "include": "楓幣圖示和完整持有數量",
        "manualInclude": "完整楓幣數量（可只框數字）",
        "exclude": "物品數量、價格及其他數字"
      },
      "mapName": {
        "title": "只讀取當前地圖名稱",
        "include": "完整地圖名稱文字",
        "exclude": "小地圖內容、頻道和任務提示"
      },
      "jobName": {
        "title": "只讀取職業名稱",
        "include": "等級右側上方的完整職業名稱",
        "exclude": "左側等級和下方角色暱稱"
      }
    },
    "unsaved": "有未儲存的修改",
    "savedState": "修改已儲存",
    "autoSaving": "正在自動儲存",
    "autoSaved": "已自動儲存",
    "autoSaveError": "自動儲存失敗",
    "autoSaveErrorHint": "校準位置暫未儲存，請再次調整後重試。",
    "fineTune": "位置微調",
    "moveUp": "向上移動",
    "moveDown": "向下移動",
    "moveLeft": "向左移動",
    "moveRight": "向右移動",
    "shrink": "縮小識別區域",
    "expand": "放大識別區域",
    "status": {
      "disabled": "已關閉識別",
      "queued": "等待排程",
      "running": "正在推理",
      "ready": "已確認",
      "confirming": "正在複核",
      "source-hidden": "請保持楓幣區域可見",
      "no-result": "暫未讀取到內容",
      "no-text": "沒有檢測到文字",
      "parse-failed": "文字無法解析",
      "low-confidence": "識別質量不足",
      "corrected": "已校正"
    },
    "failureReasons": {
      "capture-unavailable": "遊戲畫面擷取已停止或暫時無法使用",
      "ocr-timeout": "OCR 推理逾時，正在重試",
      "ambiguous-exp": "經驗欄位邊界不明確，正在重新辨識",
      "layout-unavailable": "缺少有效的介面定位",
      "resource-bar-conflict": "文字數值與血條比例不一致",
      "no-text": "畫面中沒有檢測到文字",
      "parse-failed": "已識別文字，但無法解析為有效資料",
      "low-confidence": "識別置信度低於當前嚴格度"
    },
    "strategyType": {
      "bar": "進度條識別",
      "ocr": "文字識別",
      "fused": "交叉識別",
      "unavailable": "暫不支援"
    }
  },
  "history": {
    "unknownMap": "未識別地圖",
    "phaseEfficiency": "階段效率",
    "title": "歷史記錄",
    "subtitle": "每次記錄的核心總結都儲存在當前裝置",
    "count": "{count} 次記錄",
    "empty": "還沒有完成的記錄",
    "emptyHint": "結束一次實時記錄後，核心總結會出現在這裡。",
    "duration": "時長",
    "expGained": "獲得經驗",
    "expPerHour": "EXP / 小時",
    "mesosDelta": "楓幣淨變化",
    "pageLabel": "歷史記錄分頁",
    "loadFailed": "歷史記錄讀取失敗，請稍後重試",
    "expandJourney": "展開階段效率",
    "collapseJourney": "收起階段效率",
    "journeyLoading": "正在讀取階段效率資料",
    "journeyLoadFailed": "階段效率資料讀取失敗",
    "journeyRetry": "重新讀取",
    "delete": "刪除",
    "deleteRecord": "刪除這條記錄",
    "deleteTitle": "刪除歷史記錄",
    "deletePrompt": "確定刪除 {date} 的這條記錄嗎？刪除後無法恢復。",
    "deleteDone": "歷史記錄已刪除",
    "deleteFailed": "刪除失敗，請稍後重試",
    "transferHint": "遷移已結束的歷史記錄及階段效率；識別設定和校準資料不會包含其中。",
    "export": "匯出記錄",
    "import": "匯入記錄",
    "exportDone": "已匯出 {count} 條歷史記錄",
    "exportFailed": "歷史記錄匯出失敗，請稍後重試",
    "importTitle": "確認匯入歷史記錄",
    "importConfirm": "合併匯入",
    "importConfirmIntro": "將合併匯入 {count} 條歷史記錄，本機記錄不會被覆蓋。",
    "importExportedAt": "檔案匯出時間",
    "importDuplicates": "完全重複，將跳過",
    "importConflicts": "同 ID 衝突，將重新命名",
    "importMergeHint": "匯入會一次性寫入；檔案中任意記錄無效時，不會寫入任何資料。",
    "importDone": "已新增 {imported} 條，跳過 {skipped} 條重複記錄，重新命名 {remapped} 條衝突記錄",
    "importDisabledRecording": "請先結束當前記錄，再匯入歷史資料",
    "importTooLarge": "檔案超過 64 MiB，無法匯入",
    "importInvalidJson": "檔案不是有效的 JSON 歷史記錄",
    "importInvalidFormat": "無法識別該歷史記錄檔案",
    "importUnsupported": "該歷史記錄檔案版本暫不支援",
    "importInvalidData": "檔案中的歷史資料不完整或已損壞，未匯入任何記錄",
    "importLimitExceeded": "檔案中的記錄或階段效率資料超過安全上限",
    "importWriteFailed": "歷史記錄寫入失敗，未匯入任何資料",
    "importFailed": "歷史記錄匯入失敗，請檢查檔案後重試",
    "clear": "清除所有記錄",
    "clearTitle": "清除歷史記錄",
    "clearPrompt": "這會刪除當前瀏覽器中的全部歷史記錄，且無法撤銷。",
    "clearDone": "歷史記錄已清除",
    "clearFailed": "歷史記錄清除失敗，請稍後重試",
    "clearDisabledRecording": "請先結束當前記錄，再清除歷史資料"
  },
  "rank": {
    "title": "升級效率排行",
    "subtitle": "按等級、職業與資料來源比較各地圖的可信 EXP 效率",
    "filters": "排行榜篩選",
    "levelBucket": "等級段",
    "levelRange": "Lv.{start}–{end}",
    "job": "職業",
    "allJobs": "全部職業",
    "jobRecords": "{count} 條記錄",
    "source": "資料來源",
    "sourceName": {
      "all": "全部來源",
      "mxdc": "小冊子",
      "fengji": "楓記"
    },
    "qualificationRule": "至少 {users} 位玩家參與，累計有效時長達到 {duration}；每位玩家的有效記錄滿 {perUser} 後計入。",
    "tabs": "排行榜型別",
    "formal": "正式排行",
    "accumulating": "積累中",
    "formalTitle": "正式排行",
    "formalHint": "已達到有效使用者數和可信時長門檻，適合用於地圖效率比較。",
    "accumulatingTitle": "積累中的地圖",
    "accumulatingHint": "參與人數或有效時長還不夠，當前經驗資料僅供參考。",
    "rank": "名次",
    "map": "地圖",
    "typicalEfficiency": "典型效率",
    "commonRange": "常見效率範圍",
    "highReference": "較高效率參考",
    "trustedSamples": "可信樣本",
    "currentReference": "當前典型效率",
    "rateValue": "{value} EXP / 小時",
    "users": "{count} 位使用者",
    "hours": "{count} 小時",
    "sourceBreakdown": "楓記 {fengji} · 小冊子 {mxdc}",
    "userProgress": "有效使用者 {current}/{target}",
    "durationProgress": "可信時長 {current}/{target}",
    "userThreshold": "正式榜參與人數進度",
    "durationThreshold": "正式榜有效時長進度",
    "resultCount": "共 {count} 張地圖",
    "updatedAt": "資料更新於 {time}",
    "rowUpdatedAt": "更新於 {time}",
    "refresh": "重新整理排行",
    "retry": "重新載入",
    "loading": "正在載入排行榜",
    "refreshing": "正在更新",
    "pagination": "排行榜分頁",
    "statisticsHelp": "典型效率代表中間水平；常見效率範圍覆蓋中間一半的使用者樣本；較高效率參考代表表現較高的使用者水平，並非速度上限。",
    "metadataWarning": "篩選資訊暫時無法讀取，當前使用預設範圍與排行門檻。",
    "metadataStaleWarning": "篩選資訊更新失敗，當前繼續使用已有資訊。",
    "emptyTitle": "暫無符合條件的地圖",
    "emptyFormalHint": "切換等級段、職業或來源，或稍後再來檢視。",
    "emptyAccumulatingHint": "當前篩選下還沒有正在積累的地圖。",
    "error": {
      "network": "無法連線排行榜服務，請檢查網路後重試。",
      "response": "排行榜服務暫時不可用，請稍後重試。",
      "invalid-data": "排行榜返回了無法識別的資料，請稍後重試。"
    }
  },
  "changelog": {
    "title": "更新日誌",
    "subtitle": "楓記的功能更新、體驗最佳化與問題修復。",
    "timelineLabel": "楓記更新記錄",
    "latest": "當前",
    "directory": "更新目錄",
    "changeCount": "{count} 項更新",
    "categories": {
      "added": "新增功能",
      "improved": "體驗最佳化",
      "fixed": "問題修復"
    },
    "announcement": {
      "title": "更新公告",
      "history": "檢視更新日誌",
      "dismiss": "知道了",
      "close": "關閉更新公告"
    },
    "releases": {
      "update20261031": {
        "items": {
          "gcwPercentageExp": { "title": "GCW 百分比經驗", "description": "僅顯示百分比時，也可估算經驗收益與效率。" },
          "historyRecovery": { "title": "歷史資料救援", "description": "支援匯出可用記錄，單獨儲存異常原始資料。" },
          "widgetSkins": { "title": "小工具外觀", "description": "重製 12 款主題，改善不同視窗尺寸下的顯示。" },
          "precisionCalibration": { "title": "辨識校準", "description": "支援放大、逐像素微調及直接切換遊戲類型。" },
          "personalMapReference": { "title": "個人練圖參考", "description": "改善效率區間計算，更貼近日常練圖表現。" },
          "experienceRecognition": { "title": "經驗與狀態", "description": "改善經驗、HP／MP 辨識及更新延遲，修正部分升級統計偏差。" },
          "buffReminders": { "title": "BUFF 提醒", "description": "改善圖示辨識，修復同時觸發多個提醒時的語音漏播及過期提醒延遲播放。" },
          "captureRecovery": { "title": "共享恢復", "description": "修正擷取停滯誤判，改善切回頁面及重新共享後的恢復。" }
        }
      },
      "update20261027": {
        "items": {
          "personalMapReference": { "title": "個人練圖參考", "description": "排行榜標記練過的地圖，顯示目前瀏覽器的歷史效率區間。" },
          "rankEntry": { "title": "地圖排行榜", "description": "進入地圖排行榜時，自動顯示目前等級與職業的地圖排行。" },
          "liveDashboard": { "title": "控制面板", "description": "調整經驗、金幣與圖表版面，完善狀態提示及窄螢幕顯示。" },
          "buffAlerts": { "title": "BUFF 提醒", "description": "強化即將到期提示，放大小工具圖示。" },
          "expPreview": { "title": "經驗預覽", "description": "修復預覽與已確認讀數不一致的問題。" },
          "mesosRecognition": { "title": "金幣識別", "description": "修復部分情境下的金幣識別問題。" },
          "resourceLoading": { "title": "語音與資源", "description": "改善重新整理、網路緩慢及請求受限時的載入問題。" }
        }
      },
      "update20261025": {
        "items": {
          "customBuffAudio": { "title": "BUFF 自訂音訊", "description": "支援上傳、試聽和管理提醒音效，僅存於目前瀏覽器。" },
          "mapEfficiency": { "title": "地圖參考效率", "description": "改善職業匹配與顯示。" },
          "rankFilters": { "title": "排行榜篩選", "description": "優化職業圖示、版面間距及展開動效。" },
          "buffSearch": { "title": "BUFF 搜尋", "description": "改善 GCW 多 BUFF 搜尋與重新識別。" },
          "buffCountdown": { "title": "BUFF 倒數計時", "description": "一般模式下，數字消失後暫停舊倒數計時及尚未播放的提醒。" },
          "buffIcons": { "title": "圖示識別", "description": "改善 GCW 小尺寸輕功漏識別。" }
        }
      },
      "update20261023": {
        "items": {
          "multiJobFilter": { "title": "多職業篩選", "description": "排行榜支援同時選擇多個職業，可依職業大類、分支或具體轉職組合篩選。" },
          "buffManagement": { "title": "BUFF 管理入口", "description": "設定頁可統一新增、管理 BUFF，未連接遊戲也能設定提醒。" },
          "sessionStart": { "title": "記錄啟動更順暢", "description": "確認經驗後即可開始計時，等級、地圖等資訊隨後補齊。" },
          "gameRecognition": { "title": "遊戲識別", "description": "改善經典介面經驗誤讀、中斷，以及 GCW 等級和地圖識別。" },
          "expAccounting": { "title": "經驗累計", "description": "修復部分升級、死亡及斷線恢復情境中的統計偏差。" },
          "buffRecognition": { "title": "BUFF 識別", "description": "減少相似圖示誤判與倒數計時誤重設，修正新增時的輸入驗證和預設設定。" }
        }
      },
      "update20261020": {
        "items": {
          "manboVoice": { "title": "曼波語音提醒", "description": "中文預設使用曼波音色，也可選擇系統提供的粵語、臺灣等音色。" },
          "manualBuffTimer": { "title": "BUFF 手動計時", "description": "首次辨識到有效倒數計時後獨立計時，到期按設定時長循環，不受後續畫面遮擋影響。手動模式不會同步遊戲中的 BUFF 續放，中斷連線後停止。" },
          "dropSellPrice": { "title": "掉落物顯示出售價格", "description": "掉落物詳情中新增出售價格，方便查看物品價值。" },
          "sessionAutosave": { "title": "記錄自動儲存", "description": "記錄期間每 60 秒儲存一次進度，減少頁面意外關閉造成的資料遺失。" },
          "runtimePerformance": { "title": "降低執行負擔", "description": "優化低負載模式的辨識排程，減少小工具、日常面板和經驗圖表的重複計算。" },
          "dashboardCards": { "title": "控制面板更靈活", "description": "關閉辨識後可隱藏楓幣或 HP／MP 區域，保留 BUFF 顯示。" },
          "buffCountdown": { "title": "BUFF 倒數計時更穩定", "description": "改善複雜背景和小字級辨識，減少倒數計時中斷、誤讀與漏提醒。" },
          "recognitionAccuracy": { "title": "經驗、楓幣與狀態辨識", "description": "改善經驗、楓幣及 HP／MP 讀取，提高高解析度畫面下的辨識穩定性。" }
        }
      },
      "update20261014": {
        "items": {
          "experienceSettings": { "title": "經驗設定", "description": "升級預估改為預設使用即時速度，可切換平均速度及小時／分鐘顯示單位。" },
          "attributeRecognition": { "title": "屬性欄辨識", "description": "國服懷舊服可從屬性欄讀取等級、職業、經驗及 HP／MP，支援回退到底欄。" },
          "recognitionPerformance": { "title": "辨識效能", "description": "優化畫面擷取、減少重複計算和圖像讀取；4K 測試情境下 BUFF 每影格圖像讀取量減少約 23%。" },
          "journeyChart": { "title": "練級曲線", "description": "增加時間範圍切換、平均線、峰值、地圖及中斷區間，支援點擊固定讀數。" },
          "gcwRecognition": { "title": "GCW 辨識", "description": "改善超寬螢幕下的狀態列、地圖和楓幣定位。" },
          "buffCountdown": { "title": "BUFF 倒數計時誤讀", "description": "修復部分彩色、小字級 BUFF 倒數計時誤讀。" },
          "widgetDisplay": { "title": "小工具顯示", "description": "修復小工具文字溢出、版面恢復及升級預估顯示問題。" },
          "expChartContinuity": { "title": "經驗曲線中斷", "description": "修復經驗複核期間正常曲線被不必要地中斷。" },
          "captureFrameRate": { "title": "擷取影格率限制", "description": "修復部分情境下擷取影格率限制未正確套用的問題。" }
        }
      },
      "update20261010": {
        "items": {
          "historyTools": { "title": "升級歷史記錄體驗", "description": "新增地圖統計、記錄搜尋、雙記錄比較與批次刪除，支援分欄查看詳情。" },
          "widgetWindowModes": { "title": "新增小工具開啟方式", "description": "可選擇置頂子母畫面或獨立視窗，並記住上次選擇。" },
          "gcwRecognition": { "title": "優化 GCW（國際懷舊服）辨識", "description": "改善小尺寸介面、經驗數字與楓幣讀取，優化背包移動及手動框選後的辨識恢復。" },
          "buffDetection": { "title": "修復 BUFF 漏辨識", "description": "減少經驗加成等圖示移動後無法辨識的問題。" }
        }
      },
      "update20261008": {
        "items": {
          "gcwSupport": { "title": "新增 GCW（國際懷舊服）支援", "description": "自動適配英文遊戲介面，辨識等級、經驗、HP、MP、楓幣、地圖與職業。" },
          "defaultWidget": { "title": "重構預設小工具", "description": "重新排列經驗效率、即時速率、升級進度與 BUFF，原預設樣式保留為「經典」。" },
          "compactWidget": { "title": "優化小視窗顯示", "description": "改善窄視窗中的數值、按鈕與記錄時長排版，減少裁切和遮擋。" }
        }
      },
      "update20261005": {
        "items": {
          "historyStatistics": { "title": "重構歷史記錄頁面", "description": "依日、週、月查看收益與效率，支援趨勢圖、記錄日曆和週期比較。" },
          "expRecognition": { "title": "修復經驗異常", "description": "減少經驗誤讀與異常時速，優化讀數恢復及主頁面、小工具顯示一致性。" },
          "expRateExplanation": { "title": "優化效率說明", "description": "區分本場平均與近 60 秒效率，顯示曲線資料累積進度。" },
          "buffRecognition": { "title": "優化 BUFF 辨識", "description": "改善不同解析度下的圖示和倒數計時辨識，減少相似圖示混淆。" },
          "widgetExperience": { "title": "優化小工具", "description": "新增首次調整視窗大小的引導和職業資訊，調整按鈕與經驗曲線版面。" }
        }
      },
      "update20260930": {
        "items": {
          "currentMap": { "title": "目前地圖", "description": "即時記錄時，可查看辨識到的地圖、怪物與掉落物，並參考相近等級和職業的練級效率。" },
          "dropDetails": { "title": "掉落資訊", "description": "地圖詳情新增掉落率與來源怪物資訊，可依怪物篩選掉落物。" },
          "liveLayout": { "title": "控制面板頁版面優化", "description": "調整控制面板頁版面，讓練級曲線和目前地圖資訊更方便查看。" },
          "skinPreview": { "title": "小工具外觀預覽優化", "description": "選取或查看外觀時展示不同視窗尺寸，並更新玩具熊的動畫與素材。" },
          "widgetRecovery": { "title": "修復小工具顯示異常", "description": "提升小工具顯示異常時的恢復能力，避免內容出錯影響開始、暫停和結束記錄。" },
          "shortSessions": { "title": "清理過短的記錄", "description": "結束後不足 5 秒的記錄不再留在歷史記錄中。" }
        }
      },
      "update20260928": {
        "items": {
          "realtimeRateChart": { "title": "即時速率曲線", "description": "即時頁與小工具新增近 5 分鐘經驗時速曲線，更直觀感受練級節奏起伏。" },
          "widgetLayout": { "title": "小工具版面優化", "description": "調整小工具內資訊排版與間距，核心數值與速率曲線更易一眼看清，不同外觀下也更整齊。" }
        }
      },
      "update20260924": {
        "items": {
          "buffAlerts": { "title": "BUFF 提醒", "description": "新增想關注的 BUFF，連線遊戲畫面後自動監控；支援即將結束或消失時語音播報、圖示閃爍提醒。" },
          "rateUnits": { "title": "小時／分鐘單位切換", "description": "經驗與楓幣速率可按小時或分鐘顯示，在設定中切換即可；統計結果不會改變。" },
          "lightweightOcr": { "title": "輕量文字辨識模型", "description": "可選輕量模型，降低裝置負載；標準模型辨識更準確。" },
          "artaleSupport": { "title": "支援阿爾泰", "description": "支援辨識阿爾泰遊戲介面，連線畫面後可依對應版面讀取角色與練級資料。" },
          "newLanguages": { "title": "新增三種介面語言", "description": "現已支援繁體中文、日文和韓文，可在設定中切換。" },
          "userExperience": { "title": "操作體驗更順暢", "description": "調整設定、辨識與資料顯示的操作細節，讓常用功能更容易找到和使用。" },
          "recognitionAccuracy": { "title": "提升辨識準確度", "description": "改進畫面定位與文字讀取，減少部分情況下的誤讀和漏讀。" },
          "widgetDisplay": { "title": "修復小工具顯示異常", "description": "修復部分尺寸或狀態下的小工具內容顯示錯誤。" },
          "styleIssues": { "title": "修復介面樣式問題", "description": "調整部分頁面和控制項的顯示細節。" }
        }
      },
      "update20260918": {
        "items": {
          "rankPageRebuild": {
            "title": "排行榜頁面重做",
            "description": "新增顯示地圖掉落和地圖搜尋功能，排版最佳化，內容更豐富。"
          },
          "browserCompatibility": {
            "title": "更多瀏覽器能用",
            "description": "不是官方 Edge / Chrome 時，也會盡量能選窗、開啟小工具。沒法置頂或識別不到時，會直接說明原因。用最新版 Edge 或 Chrome 不受影響。"
          },
          "captureTimeout": {
            "title": "最佳化連線超時問題",
            "description": "第一次選窗或再次開啟網頁時，更少卡住或轉圈。"
          }
        }
      },
      "update20260914": {
        "items": {
          "realtimeExpRate": {
            "title": "實時經驗速率",
            "description": "EXP / 小時旁會顯示近 1 分鐘相對全程平均的快慢；偏快或偏慢時出現箭頭，懸停可看詳情。"
          },
          "firstUseAutoLocate": {
            "title": "首次連線自動識別",
            "description": "第一次連上游戲畫面後自動開啟「自動識別」。保持狀態列可見即可，開啟道具欄還能識別楓幣；不想用可以跳過。"
          },
          "clearerMetrics": {
            "title": "資料顯示更直觀",
            "description": "收起次要欄位，突出經驗速率、楓幣時速等核心數值。"
          }
        }
      },
      "update20260913": {
        "items": {
          "autoLocateMesos": {
            "title": "自動識別楓幣",
            "description": "開啟道具欄並保持楓幣可見即可一併定位；未找到時可單獨「重試楓幣」。"
          },
          "factoryReset": {
            "title": "恢復出廠設定",
            "description": "設定頁可清除記錄與設定、識別資源；準備失敗或連不上畫面時也會提示。"
          },
          "pipWindowSize": {
            "title": "小工具記住視窗大小",
            "description": "下次開啟沿用上次調整的大小。"
          },
          "calibrationPreview": {
            "title": "校準預覽更好框",
            "description": "預覽按畫面比例居中，避免變形；小框更容易點到和拖動。"
          },
          "recoveryPaths": {
            "title": "識別失敗多兩條出路",
            "description": "準備或採集失敗時可恢復出廠設定，或更新瀏覽器後重試；自動識別超時也會提示。"
          },
          "highDpiRecognition": {
            "title": "高解析度下識別有誤",
            "description": "按實際採集畫素定位，遊戲內部解析度不必與採集尺寸一致。HUD 約覆蓋 0.5～4 倍介面。"
          },
          "upgradeExpAccounting": {
            "title": "升級時經驗不再誤記成損失",
            "description": "經驗突降先等等級確認，確認升級後補記跨級經驗；未確認則標不完整，不再記成負數。"
          }
        }
      },
      "update20260910": {
        "items": {
          "newLayoutAutoLocate": {
            "title": "適配遊戲新版UI，校準「自動識別」",
            "description": "一鍵定位等級、職業、HP、MP、經驗與地圖名；楓幣需開啟道具欄後手動框選。支援多尺寸與縮放，可檢視進度並匯出診斷，未定位項可重試。"
          },
          "rankMapTip": {
            "title": "排行榜地圖資料",
            "description": "懸停地圖名或點「詳情」，可檢視小地圖、區域、怪物與 NPC 等資料。"
          },
          "calibrationSimpler": {
            "title": "校準更簡單",
            "description": "HP / MP / 經驗只需框文字行，色條自動校驗。各採集尺寸分別記憶，可一鍵恢復預設；識別結果與未採用原因更清晰。"
          },
          "jobLineRecognition": {
            "title": "職業識別更準",
            "description": "先定位職業名所在行再識別，減少誤讀等級或暱稱。"
          }
        }
      },
      "update20260909": {
        "items": {
          "recognitionPerformance": {
            "title": "大幅提升識別效能，重構效能設定",
            "description": "用「低 / 中 / 預設 / 高 / 超高」五檔統一調節採集與識別頻率。新使用者和舊設定升級均使用「預設」檔；低、中檔負載更輕，資料更新也更慢。同時修復了工作列卡住、無響應的問題。"
          },
          "hpMpRates": {
            "title": "移除 HP / MP 消耗時速",
            "description": "實時頁和小工具僅保留 HP / MP 當前值、最大值和狀態條，移除消耗、恢復及小時速率。歷史卡片突出地圖、角色、經驗和楓幣。"
          },
          "lowFrequencyMesos": {
            "title": "低頻讀取時，楓幣統計更穩",
            "description": "道具欄持續開啟時，低頻讀取也能連續統計淨收益。收起道具欄、畫面不確定、暫停或切換共享時，仍會斷開統計銜接。"
          },
          "mapRomanSuffix": {
            "title": "修復地圖名羅馬數字字尾識別",
            "description": "儘量還原地圖名末尾誤讀的羅馬數字（如 III），減少名稱被截斷或拆分。"
          }
        }
      },
      "update20260908": {
        "items": {
          "streamSkins": {
            "title": "小工具外觀",
            "description": "新增冒險狀態列、極簡戰報、蘑菇夥伴及雪原遠征、玩具城積木站、皮卡啾電臺、墮落城市塗鴉、深海潛航等直播外觀，支援輕微待機與升級動效，替換原天空之城、櫻花庭院、奧術星輝外觀。"
          },
          "streamConnect": {
            "title": "接入直播引導",
            "description": "設定頁新增「接入直播」引導：開啟小工具、選擇摳色背景，再按步驟在 OBS 等工具中新增視窗捕獲和色鍵濾鏡。"
          },
          "allLevelRankings": {
            "title": "排行榜檢視全部等級",
            "description": "練級地圖排行支援檢視「全部」等級，各等級段獨立計算和展示，避免跨等級混比效率。"
          },
          "localDiagnostics": {
            "title": "效能與本地診斷",
            "description": "設定頁底部可分別限制採集幀率與畫面檢查頻率，降低裝置負載。本地診斷報告支援檢視、複製和下載，不自動上傳，不含截圖、OCR 原文或視窗標題。"
          },
          "screenCaptureFallback": {
            "title": "視窗採集失敗可改採整屏",
            "description": "遊戲視窗採集失敗時，可直接嘗試採集整屏，並檢視視窗化、瀏覽器、顯示卡驅動等排查步驟，複製診斷資訊方便反饋。"
          },
          "recognitionRecovery": {
            "title": "識別更穩、卡頓更好恢復",
            "description": "畫面未變化時減少重複增強；OCR 連續失敗時放慢重試，成功後恢復正常節奏，減少識別卡頓和反覆重置。"
          },
          "captureFailureGuidance": {
            "title": "採集失敗提示更清楚",
            "description": "採集失敗、超時或暫時不可用時，說明具體原因，並提供改採整屏、重選視窗和更多排查入口。"
          },
          "jobRecognition": {
            "title": "職業框誤讀等級或暱稱",
            "description": "收緊職業識別範圍，減少將相鄰的等級或暱稱誤讀為職業。"
          }
        }
      },
      "update20260907": {
        "items": {
          "mapRanking": {
            "title": "練級地圖排行（Beta）",
            "description": "按等級段、職業和資料來源比較地圖經驗效率，為練級選圖提供參考。"
          },
          "widgetSkins": {
            "title": "小工具外觀",
            "description": "新增多款小工具外觀，可在設定中切換，搭配喜歡的練級介面。"
          },
          "efficiencyChart": {
            "title": "效率趨勢圖重做",
            "description": "更直觀地呈現練級過程。控制面板和歷史記錄中的階段效率圖支援框選放大、拖動檢視時段，雙擊即可恢復全覽。"
          },
          "calibrationExamples": {
            "title": "校準框選示例",
            "description": "新增識別區域框選示例，幫助對照畫面完成校準。"
          },
          "autoRegion": {
            "title": "自動識別框選位置",
            "description": "自動定位識別區域，減少手動框選與校準操作。"
          },
          "recognitionPerformance": {
            "title": "識別效能大幅最佳化",
            "description": "大幅降低識別開銷，減少對遊戲幀數的影響，讓記錄過程更流暢。"
          },
          "startFeedback": {
            "title": "開始記錄失敗時提示明確原因",
            "description": "等級或完整經驗尚未確認、識別偏慢、共享畫面中斷時，會彈出具體原因與調整入口，減少反覆重試。"
          },
          "responsiveWidget": {
            "title": "小工具佈局更靈活",
            "description": "增強不同尺寸下的自適應佈局，自由調整視窗大小，緊湊或寬屏都能清晰檢視資料。"
          },
          "firefoxCompatibility": {
            "title": "Firefox 瀏覽器相容性修復",
            "description": "修復 Firefox 瀏覽器無法正常使用的問題。"
          },
          "recordingStart": {
            "title": "修復無法開始記錄的問題",
            "description": "修復部分玩家無法開始記錄的異常，提升啟動記錄的穩定性。"
          }
        }
      },
      "update20260904": {
        "items": {
          "expRate": {
            "title": "經驗速率",
            "description": "按“本次獲得經驗 ÷ 記錄時長”計算 EXP / 小時，升級時銜接前後的經驗。"
          },
          "mesosAccuracy": {
            "title": "楓幣識別",
            "description": "加強道具欄開關與餘額變化的連續確認，減少錯誤讀數引起的楓幣時速異常。"
          },
          "startupSpeed": {
            "title": "啟動載入",
            "description": "選擇視窗後按需準備識別資源，減少首次進入的等待與資源佔用。"
          },
          "windowSelection": {
            "title": "視窗選擇",
            "description": "降低開啟共享視窗前的後臺負載，緩解視窗選擇器卡頓。"
          },
          "efficiencyTrend": {
            "title": "升級效率趨勢",
            "description": "在控制面板檢視效率變化，新記錄的趨勢同步儲存在本地歷史中。"
          }
        }
      },
      "launch20260902": {
        "summary": "首個可用版本上線，支援在瀏覽器中本地識別遊戲畫面並記錄經驗、楓幣等練級資料。"
      }
    }
  },
  "settings": {
    "title": "設定",
    "subtitle": "管理介面、識別效能與本地重置",
    "language": "介面語言",
    "languageHint": "切換後立即應用，並儲存在當前瀏覽器",
    "theme": "外觀模式",
    "appearanceHint": "調整介面語言、日夜主題與速率單位",
    "themeMode": "日夜模式",
    "themeHint": "選擇更適合當前環境的顯示方式",
    "light": "日間模式",
    "dark": "夜間模式",
    "pipSkin": "小工具設定",
    "pipSkinDefault": "預設",
    "pipSkinClassic": "經典",
    "recognition": "讀取與識別",
    "recognitionHint": "分別調整各項資料的讀取速度與識別策略。",
    "captureRateUnit": "{count} 次/秒",
    "frequencyDetails": "各項讀取頻率",
    "recognitionIntervalSeconds": "每 {count} 秒 1 次",
    "recognitionIntervalPerSecond": "每秒 {count} 次",
    "recognitionDisabled": "不識別",
    "recognitionRequired": "記錄必需",
    "recognitionAutomatic": "自動識別",
    "recognitionDisabledState": "已關閉識別",
    "metricFrequencyHint": "EXP、楓幣和 HP/MP 預設每秒 1 次，等級和地圖每 4 秒 1 次，職業每 30 秒 1 次。裝置繁忙時實際讀取會順延。",
    "metricFrequencyAria": "{metric}讀取頻率",
    "metricFrequency": {
      "exp": {
        "label": "EXP",
        "hint": "經驗變化與升級"
      },
      "mesos": {
        "label": "楓幣",
        "hint": "需開啟道具欄"
      },
      "hpMp": {
        "label": "HP / MP",
        "hint": "數值、消耗與恢復"
      },
      "hp": {
        "label": "HP",
        "hint": "數值、消耗與恢復"
      },
      "mp": {
        "label": "MP",
        "hint": "數值、消耗與恢復"
      },
      "level": {
        "label": "等級",
        "hint": "升級與等級校正"
      },
      "mapName": {
        "label": "地圖",
        "hint": "當前地圖名稱"
      },
      "jobName": {
        "label": "職業",
        "hint": "遊戲職業"
      }
    },
    "minConfidence": "識別嚴格度",
    "minConfidenceHint": "越高越謹慎，可減少低質量結果被採用。",
    "changeThreshold": "畫面變化靈敏度",
    "changeThresholdHint": "數值越低，越容易發現畫面變化並重新讀取。",
    "restoreRecommendedRecognition": "恢復預設",
    "recognitionRestored": "已恢復預設識別設定",
    "backgroundRecording": "設定防止暫停",
    "backgroundHint": "Chrome 和 Edge 可能會為節省記憶體暫停長期處於後臺的網頁，識別與記錄也會暫時停下。把楓記加入瀏覽器的常駐名單，可以明顯減少這種中斷。",
    "setupPath": "設定路徑",
    "chromePath": "設定 → 效能 → 記憶體節省程式 → 始終讓這些網站保持活動狀態",
    "edgePath": "設定 → 系統和效能 → 效能 → 永不將這些網站置於睡眠狀態",
    "currentDomain": "當前網站域名",
    "addDomainHint": "進入最後一項後，新增這個域名。",
    "copyDomain": "複製域名",
    "domainCopied": "已複製",
    "domainCopyDone": "當前域名已複製",
    "domainCopyFailed": "複製失敗，請手動新增當前域名",
    "reset": "重置與恢復",
    "resetBody": "將本機偏好、校準與歷史恢復為首次使用狀態。",
    "factoryReset": "恢復出廠設定",
    "factoryResetTitle": "恢復出廠設定",
    "factoryResetIntro": "這會清除當前瀏覽器中已勾選的楓記資料，並重新載入應用。",
    "factoryResetItems": {
      "data": "記錄與設定",
      "resources": "識別資源"
    },
    "factoryResetItemHints": {
      "data": "歷史、校準、偏好",
      "resources": "清除後需重新下載"
    },
    "factoryResetConfirm": "恢復出廠設定",
    "factoryResetDisabledRecording": "請先結束當前記錄，再恢復出廠設定",
    "factoryResetFailed": "恢復出廠設定失敗，請稍後重試",
    "ocrChecking": "正在檢查準備情況",
    "ocrDownloading": "正在準備畫面讀取",
    "ocrPrepared": "識別資源已準備",
    "ocrInitializing": "正在完成啟動",
    "ocrReady": "畫面讀取已就緒",
    "ocrError": "準備失敗"
  },
  "about": {
    "updates": "更新記錄",
    "disclaimer": {
      "title": "免責申明",
      "intro": "使用前，請了解工具的能力邊界與相關責任。",
      "accuracyTitle": "統計結果僅供參考",
      "accuracyBody": "畫面識別可能受解析度、遮擋或遊戲更新影響，經驗、收益與效率等統計不保證完全準確，請以遊戲內實際資料為準。",
      "usageTitle": "賬號責任與使用邊界",
      "usageBody": "請遵守所在遊戲及伺服器的使用者協議。本工具不承諾賬號絕對安全，遊戲運營方的規則與處理決定以其公告為準。",
      "accountNote": "若玩家因違反遊戲規定、使用其他第三方軟體等與本工具無關的原因，導致賬號異常、限制登入或封禁，相關後果與本工具無關，由玩家自行承擔。",
      "rightsTitle": "尊重版權與權益",
      "rightsBody": "本工具中涉及的遊戲名稱、商標及素材，其權利歸原權利人所有。如有侵權或其他權益問題，請透過上方反饋渠道聯絡作者。",
      "note": "在適用法律允許的範圍內，作者不對因使用本工具產生的統計偏差、資料丟失或其他損失承擔責任；本申明不排除或限制依法不得免除的責任。"
    },
    "title": "關於",
    "subtitle": "瞭解楓記與專案作者",
    "projectDescription": "楓記是一款在瀏覽器中本地識別遊戲畫面、整理升級與經驗統計資料的記錄工具。",
    "authorLabel": "作者",
    "authorName": "小淳",
    "openAuthorBilibili": "開啟 {name} 的嗶哩嗶哩主頁",
    "contactLabel": "找到作者",
    "contactHint": "透過以下平臺檢視作者主頁與更多專案。",
    "github": "GitHub",
    "bilibili": "嗶哩嗶哩",
    "openExternal": "開啟外部網站",
    "feedbackTitle": "反饋渠道",
    "feedbackHint": "加入 QQ 群或傳送郵件反饋問題、交流使用體驗。",
    "qqGroup": "QQ 群",
    "copyGroup": "複製群號",
    "copyFeedbackGroup": "複製 QQ 群號 {number}",
    "feedbackCopied": "QQ群號已複製",
    "feedbackCopyFailed": "複製失敗，請手動複製群號",
    "email": "郵箱",
    "copyEmail": "複製郵箱",
    "copyFeedbackEmail": "複製郵箱 {email}",
    "emailCopied": "郵箱已複製",
    "emailCopyFailed": "複製失敗，請手動複製郵箱",
    "safetyTitle": "對遊戲安全嗎？",
    "safetyIntro": "楓記是純網頁端工具，無需安裝客戶端或外掛，不修改任何遊戲檔案；識別只在瀏覽器內完成，使用方式綠色輕量。",
    "safetyReport": "檢視安全性報告",
    "safetyFairLabel": "不會動遊戲",
    "safetyLocalLabel": "不出這臺電腦",
    "safetyFrame": "只看共享畫面",
    "safetyFrameHint": "接收你選擇的視窗或螢幕範圍，不儲存遊戲錄影。",
    "safetyProcess": "不接觸遊戲程式",
    "safetyProcessHint": "不讀取遊戲記憶體，也不注入或掛鉤遊戲。",
    "safetyInput": "不代替玩家操作",
    "safetyInputHint": "不會模擬鍵盤、滑鼠或向遊戲傳送任何指令。",
    "safetyPromise": "遊戲畫面只在你這臺電腦裡處理，不會上傳到網上。",
    "safetyReassure": "不索取遊戲賬號密碼，不修改遊戲或代替玩家操作。",
    "safetyHow": "共享畫面需要瀏覽器授權，由你選擇視窗或螢幕；此授權不提供遊戲記憶體或登入憑據訪問。共享整個螢幕時，請留意螢幕上可見的敏感內容。",
    "safetyStepSandbox": "瀏覽器攔住",
    "safetyStepSandboxHint": "共享畫面授權不授予讀取遊戲記憶體或登入憑據的許可權。",
    "safetyStepChoose": "你來選視窗",
    "safetyStepChooseHint": "由你選擇共享範圍；共享整個螢幕時會包含其中可見的視窗。",
    "safetyStepLocal": "本地認字",
    "safetyStepLocalHint": "只把這塊畫面當圖片，在這臺電腦裡認數字，圖片不送到網上。",
    "privacyTitle": "隱私保護",
    "privacyPromise": "不蒐集任何玩家資訊，資料全鏈路匿名。",
    "privacyIdentity": "身分資訊不蒐集",
    "privacyIdentityHint": "不索取遊戲帳號、密碼或角色名稱；不蒐集、不上傳可識別玩家身分的資訊。",
    "privacyLocal": "原始畫面留在本機",
    "privacyLocalHint": "遊戲畫面、截圖與 OCR 原文僅在瀏覽器內處理；識別區域與校準參數也只留在本機。",
    "privacyRank": "排行榜匿名統計",
    "privacyRankHint": "達標片段僅自動提交匿名統計摘要；隨機識別碼用於排行去重，不關聯遊戲帳號。",
    "privacyReport": "查看完整隱私說明"
  }
}
